<div style="padding:1.8rem !important;">
  <div class="main-container">
    <mat-card-title style="margin: 0;">
      {{projetoNome}}
    </mat-card-title>
    <div class="tool-main-container">
      <span ngbDropdown style="display: inline-block; width: 8px; margin: 0px 25px;">
        <button matTooltip="Opções" matTooltipPosition="above" class="btnCustom-default" ngbDropdownToggle><i
            class="material-icons">more_vert</i></button>
        <div ngbDropdownMenu [class.dropdown-menu-left]="isRTL">
          <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
            (click)="modalOrigemProjeto=true">Origem projeto</a>
          <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
            (click)="modalEditarProjeto=true">Editar projeto</a>
          <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
            (click)="modalEtiquetaProjeto=true">Marcadores projeto</a>
          <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
            (click)="refreshModalAlcadas();stopGetListas()">Regras projeto</a>
          <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
            (click)="modalCategoriasAnexo=true">Categorias anexo</a>
          <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
            (click)="openModalConvidarPartipante()">Convidar participantes</a>
          <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
            (click)="arquivarProjeto()">Arquivar projeto</a>
          <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
            (click)="clonarProjeto()">Clonar projeto</a>
          <a class="dropdown-item" [class.disabled]="(userAdm&&listArquivados.length>0)?null:true"
            href="javascript:void(0)" (click)="openModalDesarquivar('lista')">Desarquivar listas</a>
        </div>
      </span>

      <input class="form-control" matTooltip="Para pesquisar mais de uma expressão, separe por ;"
        matTooltipPosition="above" type="text" [(ngModel)]="mepContem" placeholder="Que contenha a expressão..."
        (keyup.enter)="filtrarCards()" style="width: 500px;">
      <button class="btnCustom-green" matTooltip="Pesquisar" matTooltipPosition="above" type="button"
        *ngIf="filtroVazio" (click)="filtrarCards()" style="height: 32px; width: 50px; margin-right: 15px;"><i
          class="material-icons">search</i></button>


      <p-dropdown matTooltip="Visualização" matTooltipPosition="above" class="type-p-dropdown" [options]="currentScreen"
        (onChange)="showDashboardScreen()" [(ngModel)]="selectedScreen" optionLabel="name" optionDisabled="inactive"
        style="margin-right: 15px;"></p-dropdown>

      <button matTooltip="Filtrar" matTooltipPosition="above" class="btnCustom-default" style="padding-right: 0px;"
        (click)="modalFiltrar = true;">
        <i class="material-icons">filter_alt</i>
        <div>Filtrar</div>
      </button>
    </div>
  </div>


  <!--<ul class="list-inline">
    <li class="list-inline-item" style="margin-left: 10px;">
      <h4 class="font-weight-bold py-3 mb-4">
        {{ projetoNome }}
        <span ngbDropdown style="display: inline-block; width: 8px;">
          <button class="btn btn-default btn-proj-edit" ngbDropdownToggle><i
              class="material-icons">more_vert</i></button>
          <div ngbDropdownMenu [class.dropdown-menu-left]="isRTL">
            <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
              (click)="modalOrigemProjeto=true">Origem projeto</a>
            <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
              (click)="modalEditarProjeto=true">Editar projeto</a>
            <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
              (click)="modalEtiquetaProjeto=true">Marcadores projeto</a>
            <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
              (click)="refreshModalAlcadas();stopGetListas()">Regras projeto</a>
            <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
              (click)="modalCategoriasAnexo=true">Categorias anexo</a>
            <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
              (click)="openModalConvidarPartipante()">Convidar participantes</a>
            <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
              (click)="arquivarProjeto()">Arquivar projeto</a>
            <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)"
              (click)="clonarProjeto()">Clonar projeto</a>
            <a class="dropdown-item" [class.disabled]="(userAdm&&listArquivados.length>0)?null:true"
              href="javascript:void(0)" (click)="openModalDesarquivar('lista')">Desarquivar listas</a>
          </div>
        </span>
      </h4>
    </li>
    <li class="list-inline-item col-sm-5">
      <input [(ngModel)]="mepContem"/>
      <div class="input-group mb-3">
        <input class="form-control" matTooltip="Para pesquisar mais de uma expressão, separe por ;" type="text"
          [(ngModel)]="mepContem" placeholder="Que contenha a expressão..." (keyup.enter)="filtrarCards()">
        <div class="input-group-append">
          <button class="btn btn-info" matTooltip="Pesquisa" type="button" *ngIf="filtroVazio" (click)="filtrarCards()"
            style="border-top-right-radius: 3px; border-bottom-right-radius: 3px;"><i class="fas fa-search"
              style="font-size: 14px;"></i></button>
          <button class="btn btn-info" matTooltip="Remover Filtro" type="button" *ngIf="!filtroVazio"
            (click)="limparFiltro()" style="border-top-right-radius: 3px; border-bottom-right-radius: 3px;"><i
              class="fas fa-filter" style="font-size: 14px;"></i></button>
          <span matTooltip="Filtro Avançado" style="padding-right: 0px;">
            <button class="btn btn-default btn-proj-edit" style="padding-right: 0px;" (click)="modalFiltrar = true;"><i
                class="material-icons">arrow_drop_down</i></button>
          </span>
        </div>
      </div>
    </li>
    <li class="list-inline-item">
      <div>
        <ul class="list-inline filter-menu mb-3">
          <li class="list-inline-item">
            <h4 class="font-weight-bold py-3 mb-4" style="margin-right: 0.2rem;">Visualização:</h4>
          </li>
          <li class="list-inline-item">
            <p-dropdown class="type-p-dropdown" [options]="currentScreen" (onChange)="showDashboardScreen()"
              [(ngModel)]="selectedScreen" optionLabel="name" optionDisabled="inactive"></p-dropdown>
          </li>
        </ul>

      </div>
    </li>
  </ul>-->

  <!-- alert -->
  <div class="ui-g" style="position: fixed; right: 15px;  bottom: 5px; max-width: 500px;">
    <div class="ui-g-12">
      <p-messages [value]="msgs" (click)="hideMessage()"></p-messages>
      <p-messages [value]="msgsItem" (click)="hideMessage()"></p-messages>
      <p-messages [value]="msgsLista" (click)="hideMessage()"></p-messages>
    </div>
  </div>

  <div class="board-canvas" *ngIf="!modalAlcadas">
    <div #container class="container row" dragula="LISTAS" [(dragulaModel)]="listas" *ngIf="dashboardScreen1">
      <div class="col col-extra col-background" *ngFor="let list of listas" [attr.list-id]="list.id">
        <div class="ml-5">
          <span *ngIf="(list.aprovador!==null)" matTooltip="Aprovador: {{list.aprovadorNome}}"
            class="d-flex content-class-aprovador"><i class="ion d-block ion-md-checkbox-outline"></i></span>
          <div ngbDropdown>
            <button class="btn btn-default p-0" ngbDropdownToggle><i class="material-icons">more_vert</i></button>
            <div ngbDropdownMenu [class.dropdown-menu-left]="isRTL">
              <a class="dropdown-item" [class.disabled]="userAdm?null:true" href="javascript:void(0)"
                (click)="openModalDefinirAprovador(list)">
                {{ ((list.aprovador===null) ? 'Definir aprovador da lista' : 'Aprovador: ' + list.aprovadorNome) }} </a>
              <!-- <a class="dropdown-item" [class.disabled]="userAdm ? null:true" href="javascript:void(0)">Ordenar lista</a> -->
              <a class="dropdown-item" [class.disabled]="userAdm?null:true" href="javascript:void(0)"
                (click)="arquivarLista(list)">Arquivar lista</a>
              <a class="dropdown-item" [class.disabled]="list.subitems.length>0&&userAdm?null:true"
                href="javascript:void(0)" (click)="arquivarTodos(list)">Arquivar todos os cards</a>
              <a class="dropdown-item"
                [class.disabled]="(list.aprovador!==null&&list.id===1)?true:(listas.length>1&&list.subitems.length>0)?null:true"
                href="javascript:void(0)" (click)="moveAll=true;openModalMoverCards(list)">Mover todos os cartões</a>
              <a class="dropdown-item"
                [class.disabled]="(list.aprovador===sessionService.loggedUser.id&&list.id!==listas.length&&list.subitems.length>0)?null:true"
                href="javascript:void(0)" (click)="assinarCards(list)">Aprovar todos cartões</a>
              <a class="dropdown-item" [class.disabled]="(list.id!==listas.length)?null:true" href="javascript:void(0)"
                (click)="definirPainelFinal(list)">Definir lista como final</a>
              <a class="dropdown-item" [class.disabled]="(userAdm&&list.subitemsArquivados.length>0)?null:true"
                href="javascript:void(0)" (click)="indexCurrentPainel=list;openModalDesarquivar('cartão')">Desarquivar
                cartões</a>
              <!-- [class.disabled]="userAdm ? null:true" -->
            </div>
          </div>
        </div>
        <!-- titulo da coluna -->
        <div class="d-flex align-items-center" [ngStyle]="{'margin-bottom':'7px'}">
          <!-- [ngStyle]="{'margin-top':(userAdm?'-23px':'0px'),'margin-bottom':'7px'}" -->
          <div *ngIf="userAdm" contenteditable="true" class="{{ userAdm ? 'some-handle' : 'disabled' }} editable-div"
            (click)="editandoTitulo(list.id);" id="{{ list.id }}" (focusin)="onFocusInEditable()"
            (focusout)="updatePainel(list.id)">
            {{ list.name }}
          </div>
          <div *ngIf="!userAdm" contenteditable="false" class="{{ userAdm ? 'some-handle' : 'disabled' }} editable-div">
            {{ list.name }}
          </div>
        </div>

        <div class="card card-condenced" dragula="SUBITEM" [(dragulaModel)]="list.subitems"
          [ngStyle]="{'height': alturaDaMaiorLista + 'px'}">

          <div class="card-body" *ngFor="let subitem of list.subitems" [attr.list-id]="list.id"
            style="min-height: 175px; max-height: 175px; position: relative;"
            (click)="openModal(content,subitem.id,subitem.name,list.id)"
            [ngStyle]="{'display': enableCardView(subitem) ? 'block' : 'none'}" id="{{ getCardId(subitem) }}">
            <!--ID do cartão-->
            <div class="col-lg cartao-id">
              <div
                class="col-lg-12 id  {{(list.aprovador===null&&subitem.aprovador===null)?'handle':(list.aprovador===sessionService.loggedUser.id||subitem.aprovador===sessionService.loggedUser.id)?'handle':'disabled'}}">
                <span class="id-icon"> {{ subitem.id }} </span>

                <span *ngIf="subitem.dataFim !== null"
                  class="cartao-icones {{ (subitem.dataFim < currentDate ) ?'cartao-data-red' : 'cartao-data-green' }} "
                  matTooltip="{{ (subitem.dataFim < currentDate )?'Este cartão esta com entrega atrasada.':'Este cartão deve ser entregue mais tarde.' }}">
                  <!--: (subitem.dataFim = today ) ? 'cartao-data-yellow':-->
                  <i class="material-icons">access_time</i>
                  <span class="cartao-icones-text"> {{ subitem.dataFim | date:'dd/MM'}} </span>
                </span>

                <span matTooltip="{{subitem.prioridade}}" *ngIf="subitem.prioridadeId > 0"
                  class="{{(subitem.dataFim !== null ) ? 'cartao-priority-2' : 'cartao-priority-82'}} ">
                  <!--*ngIf="subitem.prioridadeId === 4"-->
                  <img *ngIf="subitem.prioridadeId === 1" class="cartao-priority-img"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wUVDSo0tSRAnwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAQ8SURBVEjHrZZrTBxVFMfPndnH7EN3caFQsaSGMqwspDzSQhNjrRaxG1oT/KAmJjUGTFxIuhUjNKakaSFu0S2YrBsjpR/6ICmNfOkmaJompqaaBqxCStldkGotLjs8ugv7YGZn5vqhdtiRWcTE+2Uyufec3z3nnvs/F2GMIdO45+kpTfw82gA8fwBz7A6cjGcDACCdYQFptNNAksOGqt1D25uddzL5QEqAadcpmp3yu4W52XrMrcJGA2kpIPO2+agi6weFbR9P/SvAf9TRxE3d7cXsqh7+w0BqTUxTXOa09nzRnxFw542DbUJk0QWiqOxFEB59SVJ5niBBlZPXbrv49el1AL/T0cROjn0FoiCzIXPz75OWnD5Cpx/e8trri5hPATM0aMYY1wvM3LvCfOhZuYEKtLbyRqvb0y8BprpO0Mlb3/+Ck3GdPG4E+uf3Hy3qONWrtOHFG99pwhfOOXkm5MKJFSSZabQxqmrPTvqka4YAAGCDd93rnAMAYAzJWzfOBDuOOZQAlhde5Er6zndrdlgPIb1RyjXmWGPqwR9nAADIw1lPlLLjt3tlqUEoPe9IYEL2aCAwb9m3f0QJlF1nDy5cv5YUo0u1EoRdta7M3Bsgm57Z0iIuMXulFOZtu6+r2HWCn5utA0FAEiQcskcDwYwQ0mQeiQcCh3F82fTIhgcMaJ7AiXitbKElp6+oo7OXqqhuQWrNWtgpFiVHb3oypmvvSxxpzjoryzDH1REAYJVVmlrtAwCgO7u9VEWNDAIpbkMIYTAOy8uapwkxsmhOr/O8t96OPP6lu7q9VGVNC6g2B7HUvrqQfpY4EcshgJBfGpHlZP90Z7dXV1XTAiq1AqRdBiENBoA0YcACDwSRlR1ZW0ECMzRo/ufO6M5ur65yPWR19AdP8PgaJHz5kjn9lhNPZi0RANgvO5hUyq6UX7rrU6+uoloGwSkOrf70oyd4vM0BAIBFsV5+UQk/2VxZli8uR/al1W8+F41+aaravU5mLS+/MhKdmJjnmbAdxL9LWBSQwMzZl6d/jaYe/N6M4ysmKSFmy1lCX1k9hDTatTNYfmiNjY+1ZlLN4k/cXqp8l7yEORYlbl7vEZg/C9JlnCopG0QYY5h4582r/OxvUnjIaMJklqXOdm7gWiZQoL3VwY6PeHCKQ0rzqoJCn63/0kECAEBbbGtFOmNS2lEsioSHi99ONjd+xAz71IqRuNxeqnKPUyYraWKn3pp/RCbXk873m7jJ8XVyTZgsQXXB9guIJH05hxoiBEVBeHDALKb4eoEJKcv1czsbHzee/7/h5D7dbjt/RWo4RPp86eWrp7Ul5e8hnSGp6IAkMzpHGm1MW1rRmO5846Yf9LuF8Gaavg5U+QU+Ve7WI/RJ18ymXhXSs+Xzz0oTY7cbMM8fAFGgcWz5KQAApDcugEodRCrVN1RJ2ZXCD4/5M/n4C3laDh5fq9iMAAAAAElFTkSuQmCC" />
                  <img *ngIf="subitem.prioridadeId === 2" class="cartao-priority-img"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAYAAAAYl8YPAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wUVDS4GGZ/UGwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAI1SURBVDjLY/z//z8DLrDi8CrB1RfXLf3+76cnJxP79lD9oOgI27D3uNQzMeABe2/tT73x5Z7nw29PGW58uee57/bBVHzq8Rr2n4FBGZn/7/8/ZbINIxWMGjZqGD0MY1l7fD37rmt7IxkY/jNI8UstrQ+p/k2s5qm7ZnCfe3g+iouV6ysXL/dKliVnV6y89eW+PwMDA4PcF8mEunXNXk1Btd8IGbThxEbJw3eO7r386aYmAwMDg8R7USumx9+f+cMUPPr+3P7ko9Pbq1fXc+MzaP2JjZIrzq3ZDzOIgYGBQZhdMJFJllPqMrLCJz9e2J16enZ72coqrAauPbZeauW5NQcuf7qpjiz+48+Pw0z+mt7Bqtzyj5Elnv14ZXv22cUdjIyMPMji/Ox8UqsvrDtw+dNNNWRxcXbhS5ri6rGM////Z1iwd5HK1hs7Dlz7fEcaWZEgK9//978/McL47ExsDD///WJAM+iiqaSRS2dE6xtGWEm7YO8i5W03dh68+vm2NLGxKc4ufMFY0tC1O6LtDQMDAwMLTCLBOe4uAwODHeMNxoNXPt+SIWyQyHljSQPX7oi2t/B0hqwgwTnuHgMDgx3DTcZDVz7dxGmgBLvIOSMJfTdkgzAMgxp4n4GBwZbxJsOhy59uymLx2lkjCX237sj2dxg5AJvNCc5xDxgYGGwZbjIcRjZQnF3kDNQgrDUUCy6vJDjHPfzP8N+G4SbDqpc/35gLsQnslheUC+/BYRADAwMDADe82hf3OKHAAAAAAElFTkSuQmCC" />
                  <img *ngIf="subitem.prioridadeId === 3" class="cartao-priority-img"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAYAAAAYl8YPAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wUVDSYi7UW6wgAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAH2SURBVDjL7dPNSxtBFADwN5ORlHWtk9ZDQbsb1INRKy00OUqEbTAEQfFQ9ObNc/+BmMS/ItBiFAM9eCi0HlRiNklvpb0ESQpFROInknVNMN0NO14kuFt3CV568d2GefPjfTCIMQZ2cZVOC383N1OgaUHU1bXt6u19T+Pxql0+ssOu1tdFTZbzxv7+y1YypT/I8HCIxmL3gtgG8mrZrAkCAGCK8ra5t7etRKPP2qpMXVvz6rKcNw4O+mzbofQnGRkJ0aWlC1tMXVnx6oWCI3QH/EVGR9/RaPTinzbV1dV+PZdrC7pt+U2zWNxRYrEeE6amUv3a7m7WODw0Qaiz0zwDQqzg62axuKPE4z0AAK4PAwODWiaTZZWKadiou7uARfE7Ozt71bL8/q9ACGKXl89biY3GC6aqk1q5vIH1TGaDVSp9FijvGhqaBICaqZJ6/cgdDgexKP62VDjWLJVS2Dg9HbNAOeLzhT3Ly/X7ZsXPzh65I5EgFoSy6R3HBTHyeL7c2ZBMfL4wTSTqTsPnZ2aO3VNTE1gQSq3qqtVPhFtYmGtsbc0DADwJhdKcJF23s01+evrYODnx6zw/jwipIYDPhJOka06SPsID4uniYg0Ako7f6aHxiD1i/x9D6I/j2RLE6bIjEEga5+fjYBgRwPhbRyCQdMq/ASFjz1iASZW5AAAAAElFTkSuQmCC" />
                  <img *ngIf="subitem.prioridadeId === 4" class="cartao-priority-img"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wUVDDcf5za/9AAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAHPSURBVDjL5VTNSxtBHH0zu/EjiZiDIeDFLiLZbVhyqCBBpZu1stCcBO+CgmfxnkP+BA+Sq3gQixcFFaMHD2KkEmO+WlLsoYIgWKmSmoSKmelBV2qcqPRU6IMfPB7vMW9+AwPOOern08REOOP3n2Y07SRvGG9EnkdCcWoqfKgoV2mApwF+6PP9yIVCwSeDnycnBzLBYMUO3Y/Hc5YPhx+EKe7wNRZ7e51MbrBsthX1uLz03uTzW9neXtWWKAB8mZ4OlZeXV1mh4EID8PNzLzs+3i4MDb0GAGnM6ewvJxIJdnDgBgDq9185Bgf3asXiKwBwRCJJXq16USrJqFTc7OJi5GxxcYWW5uc/sP19NwCQrq6fsq6/AyEp+yTS1LTnGh8fJap6fVe7k7S1rVNIkgsAiKKUWwwjElha+lhfsycWW2s2jBHS3X0brtWclPp8wzQQmJE1rV+dm9tpdEctHl9vsSyT6voMkaT3sr65mQKQwgugzs7uAti93+rf4L8N0vb2byL+J2SR2GFZ8e/VKrG5yEM45//Ico6i0b6jaLSvYVL0n+RM00pTytOU8pxpWiKPeKsezzAYAxi75S+uytgvIX/uORyKsnCj62M2F3l+A2ItCaDTEnVXAAAAAElFTkSuQmCC" />
                </span>

                <div class="col-lg-2 avatar" matTooltip="{{ subitem.responsavel }}">{{ subitem.avatar }}</div>
              </div>
            </div>

            <!--flags do cartão-->
            <div class="col-lg cartao-flags">
              <ul
                class="flags  {{(list.aprovador===null&&subitem.aprovador===null)?'handle':(list.aprovador===sessionService.loggedUser.id||subitem.aprovador===sessionService.loggedUser.id)?'handle':'disabled'}}">
                <li *ngFor="let flag of subitem.flags" [ngStyle]="{'background-color':'' + flag.corBg + ''}"
                  class="format">{{ flag.nome}}</li>
              </ul>
            </div>

            <!--texto do cartão-->
            <div
              class="card-lines-max {{(list.aprovador===null&&subitem.aprovador===null)?'handle':(list.aprovador===sessionService.loggedUser.id||subitem.aprovador===sessionService.loggedUser.id)?'handle':'disabled'}}"
              matTooltip="{{ subitem.name }}" [ngStyle]="{'min-height': subitem.flags.length > 0 ? '35%' : '45%'}">
              <div *ngIf="subitem.alcadaNome" class="box-card">
                [ {{ subitem.alcadaNome }} ] {{ subitem.name | slice:0:60 }} <label
                  *ngIf="subitem.name.length > 60">...</label>
              </div>
              <div *ngIf="!subitem.alcadaNome" class="box-card">
                {{ subitem.name | slice:0:60 }}<label *ngIf="subitem.name.length > 60">...</label>
              </div>

            </div>
            <!-- icones de ações-->
            <div class="col-lg cartao-footer" style="position: absolute; bottom: 8px; height: 25px;">
              <div
                class="col-lg-10 actions {{(list.aprovador===null&&subitem.aprovador===null)?'handle':(list.aprovador===sessionService.loggedUser.id||subitem.aprovador===sessionService.loggedUser.id)?'handle':'disabled'}}">

                <span class="cartao-icones" matTooltip="Itens da checklist." *ngIf="subitem.checkLists.length>0">
                  <!---->
                  <i class="material-icons">check_circle_outline</i>
                  <span class="cartao-icones-text"> {{ subitem.checkListsConcluidos }}/{{ subitem.qtdAtividades }}
                  </span>
                </span>

                <span class="cartao-icones comentarios" *ngIf="subitem.comentariosLength>0">
                  <i class="lnr d-block lnr-bubble"></i><span class="cartao-icones-text">{{subitem.comentariosLength}}
                  </span>
                </span>

                <span class="cartao-icones" *ngIf="subitem.anexos.length>0">
                  <i class="material-icons">attach_file</i>
                </span>

                <span *ngIf="subitem.seguindo === true" class="cartao-icones"
                  matTooltip="Você está seguindo este cartão."><i class="material-icons">remove_red_eye</i></span>

              </div>
              <div class='col-lg-2 type-p-checkbox'>
                <span
                  *ngIf="(list.id<listas.length&&(list.aprovador===sessionService.loggedUser.id||subitem.aprovador===sessionService.loggedUser.id))?true:false">
                  <p-checkbox [(ngModel)]="subitem.assinado" [binary]="true" (click)="assinarCard(subitem)">
                  </p-checkbox>
                </span>
                <span
                  *ngIf="(list.id<listas.length&&(subitem.aprovador!==null&&subitem.aprovador!==sessionService.loggedUser.id))?true:false"
                  matTooltip="Aprovador: {{subitem.aprovadorNome}}">
                  <i class="ion d-block ion-md-checkbox-outline"></i>
                </span>
              </div>

            </div>
          </div>
          <!-- c-->
        </div>
        <div *ngIf="(list.id === 1) ? true : userAdm" class="card-footer text-left py-2" style="position: relative;"
          [ngStyle]="{'bottom':alturaDaMaiorLista - (list.subitems.length * 181) > 0 ?  ((alturaDaMaiorLista - (list.subitems.length * 181))) + 'px' : ''}">

          <!-- Add do novo cartão-->
          <div id="novoCartao_{{list.id}}" (click)="adicionarCartao(true,list.id)" class="font-10-pt">
            <i class="ion ion-md-add"></i>&nbsp;Adicionar cartão
          </div>

          <!-- Decrição do novo cartão-->
          <div id="salvarCartao_{{list.id}}" class="add-new-card">
            <div class="form-row">
              <div class="form-group col-sm-12 mb-1 pr-2 pl-2 pt-1">
                <textarea class="form-control d-block" type="text" #inputCardText rows="3"
                  placeholder="Insira um título para este cartão..." [(ngModel)]="textCartao" autofocus></textarea>
                <button type="button" class="btn btn-xs btn-primary" (click)="salvarCartao(list.id);"><i
                    class="fas fa-check"></i> Salvar</button>
                <span (click)="adicionarCartao(false,list.id)"><i class="material-icons">clear</i></span>
              </div>
            </div>
          </div>

        </div> <!-- footer end-->

      </div><!-- col end -->

      <div *ngIf="listas.length === 0 || userAdm" id="novaLista" class="col-extra-add">
        <div (click)="novaLista(true)">
          <i class="ion ion-md-add"></i>&nbsp;Adicionar nova lista
        </div>
      </div>
      <div id="addNovaLista" class="col-extra-save" style="display: none">
        <div class="form-row">
          <div class="form-group col-sm-12 mb-1">
            <input type="text" class="form-control d-block" #inputTitleList placeholder="Insira o título da lista..."
              [(ngModel)]="textTitulo" />
            <button type="button" class="btn btn-xs btn-primary" (click)="adicionarLista();"><i
                class="fas fa-check"></i> Salvar</button>
            <span (click)="novaLista(false)"><i class="material-icons">clear</i></span>
          </div>
        </div>
      </div>
    </div><!-- row end -->


    <div style="display: flex; justify-content: space-between;" *ngIf="dashboardScreen2">
      <div class="shadow-box" style="border-radius: 13px; padding: 3px; max-height: 2166px;" id="shadowBox"
        [style]="{'width': '100%'}">
        <div class="header-box">
          <div class="header-box-content">
            <div>
              <ul class="list-inline filter-menu filter-card-header mt-0">
                <ul class="list-inline filter-menu filter-card-header mt-0">
                  <li class="list-inline-item" [ngClass]="{active: statusMovimentacao}"><a
                      (click)="showTelaWorkflow('TELA_1')">Movimentação</a></li>
                  <li class="list-inline-item" [ngClass]="{active: statusVencidos}">
                    <a (click)="showTelaWorkflow('TELA_2')">Tela 2</a>
                  </li>
                </ul>
              </ul>
              <div class="actions-card">
                <button type="button" [ngStyle]="statusMovimentacao ? {'display': 'inline'} : {'display': 'none'}"
                  class="btn btn-xs btn-link" (click)="exportExcel(dt, 'tableData')" matTooltip="Exportar Excel"
                  matTooltipPosition="above"><i style="font-size: 20px;" class="far fa-file-excel excel"></i>
                </button>
                <button type="button" class="btn btn-xs btn-link" (click)="ShowHIdeCardMov()"
                  (click)="changeStateMov()">
                  <span *ngIf="isCardMov" class="material-icons" style="font-size: 30px;" matTooltip="Ocultar Card"
                    matTooltipPosition="above">expand_less</span>
                  <span *ngIf="!isCardMov" class="material-icons" style="font-size: 30px;" matTooltip="Ver Card"
                    matTooltipPosition="above">expand_more</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box-content" [@changeDivSize]=currentStateMov>
          <div [ngStyle]="statusMovimentacao ? {'display': 'block'} : {'display': 'none'}"
            [ngClass]="{'fade-in': 'statusMovimentacao'}">
            <!-- vir -->
            <p-table class="table-system" #dt [value]="tableData" [columns]="cols" [pageLinks]="pageLinks"
              [paginator]="true" [rowsPerPageOptions]="rowsPerPage" [rows]="rows" [scrollable]="false"
              scrollHeight="400px" selectionMode="single" [style]="{'width': '100%'}" [(selection)]="rowsSelected"
              (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
              (onHeaderCheckboxToggle)="onSelectAll($event)">
              <ng-template pTemplate="header">
                <tr>
                  <th class="text-center tableHeaderCheckbox">
                    <span class="check-all p-0">
                      <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </span>
                  </th>

                  <th class="text-left" style="width: 10%;">
                    <span class="text-overflow-dynamic-container" [pSortableColumn]="'listName'">
                      <span class="text-overflow-dynamic-ellipsis">Lista <p-sortIcon [field]="'listName'">
                        </p-sortIcon></span>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'listName', 'contains')">
                  </th>


                  <th class="text-left" style="width: 10%;">
                    <span class="text-overflow-dynamic-container" [pSortableColumn]="'id'">
                      <span class="text-overflow-dynamic-ellipsis">Card <p-sortIcon [field]="'id'">
                        </p-sortIcon></span>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'id', 'contains')">
                  </th>

                  <th class="text-left" style="width: 30%;">
                    <span class="text-overflow-dynamic-container" [pSortableColumn]="'cardName'">
                      <span class="text-overflow-dynamic-ellipsis">Título <p-sortIcon [field]="'cardName'">
                        </p-sortIcon></span>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'cardName', 'contains')">
                  </th>

                  <th class="text-left" style="width: 15%;">
                    <span class="text-overflow-dynamic-container" [pSortableColumn]="'responsible'">
                      <span class="text-overflow-dynamic-ellipsis">Responsável <p-sortIcon [field]="'responsible'">
                        </p-sortIcon></span>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'responsible', 'contains')">
                  </th>

                  <th class="text-left" style="width: 15%;">
                    <span class="text-overflow-dynamic-container" [pSortableColumn]="'requester'">
                      <span class="text-overflow-dynamic-ellipsis">Requisitante <p-sortIcon [field]="'requester'">
                        </p-sortIcon></span>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'requester', 'contains')">
                  </th>

                  <th class="text-left" style="width: 10%;">
                    <span class="text-overflow-dynamic-container" [pSortableColumn]="'deadline'">
                      <span class="text-overflow-dynamic-ellipsis">Prazo <p-sortIcon [field]="'deadline'">
                        </p-sortIcon></span>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'deadline', 'contains')">
                  </th>

                  <th class="text-left" style="width: 10%;">
                    <span class="text-overflow-dynamic-container" [pSortableColumn]="'priority'">
                      <span class="text-overflow-dynamic-ellipsis">Prioridade <p-sortIcon [field]="'priority'">
                        </p-sortIcon></span>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'priority', 'contains')">
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr style="cursor: pointer;">
                  <td class="text-center tableCheckbox">
                    <p-tableCheckbox [value]="item"></p-tableCheckbox>
                  </td>
                  <td class="text-left">{{item.listName !== null || undefined ? item.listName : "--"}}</td>
                  <td class="text-center">{{item.id !== null || undefined ? item.id : "--"}}</td>
                  <td class="text-left" matTooltip="{{item.cardName}}">
                    {{item.cardName !== null || undefined ? item.cardName : "--"}} </td>
                  <td class="text-left">{{item.responsible !== null || undefined ? item.responsible : "--"}}</td>
                  <td class="text-left">{{item.requester !== null || undefined ? item.requester : "--"}}</td>
                  <td class="text-center" style="overflow: hidden;">{{item.deadline | date:'dd/MM/yyyy'}}</td>
                  <td class="text-center">{{item.priority !== null || undefined ? item.priority : "--"}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div class="highcharts-container">
            <highcharts-chart *ngIf="showHighcharts" [Highcharts]="Highcharts" [options]="chartOptions"
              style="height: 400px; display: block; width: 100%; min-width: 400px;">
            </highcharts-chart>
          </div>
        </div>
      </div>

      <aside class="workflow-aside" *ngIf="cloneAside.length > 0">
        <div class="aside-header">
          <ul class="list-inline filter-menu filter-card-header mt-0">
            <li class="list-inline-item" [ngClass]="{active: statusTarefas}" (click)="asideChangeScreen(0)">
              <a>Tarefas</a>
            </li>
            <li class="list-inline-item" [ngClass]="{active: statusNotificacoes}" (click)="asideChangeScreen(1)">
              <a>Notificações</a>
            </li>
          </ul>
          <button type="button" class="btnCustom-default" matTooltip="Fechar" matTooltipPosition="above"
            (click)="closeAside()" style="width: 35px;height: 35px;">
            <span class="material-icons">close</span>
          </button>
          <div class="aside-search">
            <input class="form-control form-control-sm mr-1" type="text" [(ngModel)]="filterAsideValue"
              (keyup.enter)="filterAside()" />
            <button type="button" class="btnCustom-green" matTooltip="Pesquisar" matTooltipPosition="above"
              (click)="filterAside()" style="height: 28px;">
              <span class="material-icons">search</span>
            </button>
          </div>
        </div>
        <div [ngStyle]="statusTarefas ? {'display': 'block'} : {'display': 'none'}"
          [ngClass]="{'fade-in': 'statusTarefas'}" class="aside-content" id="asideId"
          [ngStyle]="{ 'maxHeight.px': asideStyle }">
          <article *ngFor="let item of asideInformation; let i = index">
            <div class="article-header">
              <div class="article-header-title">
                <p matTooltip="{{item.id !== null ? item.id : 'Sem id para este card'}}" matTooltipPosition="above">
                  {{item.id !== null ? item.id : "Sem id para este card"}} - &nbsp;</p>
                <div class="deadline">

                  <p matTooltip="(nenhum prazo)" matTooltipPosition="above" *ngIf="item.deadline === null">(nenhum
                    prazo)</p>
                  <p matTooltip="{{item.deadline}}" matTooltipPosition="above"
                    [ngStyle]="(currentDate >= item.deadline) ? {color: '#CF2424'} : {color: '#3DB05D'}">
                    {{item.deadline | date:'dd/MM/yyyy'}}</p>
                </div>
              </div>
              <button type="button" class="btnCustom-default" (click)="showMoreItens(item, i)"
                [matTooltip]="item.showExtendedItens ? 'Ver menos' : 'Ver mais'" matTooltipPosition="above">
                <span *ngIf="!item.showExtendedItens" class="material-icons">expand_more</span>
                <span *ngIf="item.showExtendedItens" class="material-icons">expand_less</span>
              </button>
            </div>
            <div class="article-body">
              <h3 matTooltip="{{item.cardName !== null ? item.cardName : 'Sem titúlo para este card'}}"
                matTooltipPosition="above"> {{item.cardName !== null ? item.cardName : "Sem titúlo para este card"}}
              </h3>
              <div class="info-row">
                <div>
                  <div class="info">
                    <p class="title">PRIORIDADE</p>
                    <div>
                      <img class="priority" *ngIf="item.priority === 'Bloqueada' "
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wUVDSo0tSRAnwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAQ8SURBVEjHrZZrTBxVFMfPndnH7EN3caFQsaSGMqwspDzSQhNjrRaxG1oT/KAmJjUGTFxIuhUjNKakaSFu0S2YrBsjpR/6ICmNfOkmaJompqaaBqxCStldkGotLjs8ugv7YGZn5vqhdtiRWcTE+2Uyufec3z3nnvs/F2GMIdO45+kpTfw82gA8fwBz7A6cjGcDACCdYQFptNNAksOGqt1D25uddzL5QEqAadcpmp3yu4W52XrMrcJGA2kpIPO2+agi6weFbR9P/SvAf9TRxE3d7cXsqh7+w0BqTUxTXOa09nzRnxFw542DbUJk0QWiqOxFEB59SVJ5niBBlZPXbrv49el1AL/T0cROjn0FoiCzIXPz75OWnD5Cpx/e8trri5hPATM0aMYY1wvM3LvCfOhZuYEKtLbyRqvb0y8BprpO0Mlb3/+Ck3GdPG4E+uf3Hy3qONWrtOHFG99pwhfOOXkm5MKJFSSZabQxqmrPTvqka4YAAGCDd93rnAMAYAzJWzfOBDuOOZQAlhde5Er6zndrdlgPIb1RyjXmWGPqwR9nAADIw1lPlLLjt3tlqUEoPe9IYEL2aCAwb9m3f0QJlF1nDy5cv5YUo0u1EoRdta7M3Bsgm57Z0iIuMXulFOZtu6+r2HWCn5utA0FAEiQcskcDwYwQ0mQeiQcCh3F82fTIhgcMaJ7AiXitbKElp6+oo7OXqqhuQWrNWtgpFiVHb3oypmvvSxxpzjoryzDH1REAYJVVmlrtAwCgO7u9VEWNDAIpbkMIYTAOy8uapwkxsmhOr/O8t96OPP6lu7q9VGVNC6g2B7HUvrqQfpY4EcshgJBfGpHlZP90Z7dXV1XTAiq1AqRdBiENBoA0YcACDwSRlR1ZW0ECMzRo/ufO6M5ur65yPWR19AdP8PgaJHz5kjn9lhNPZi0RANgvO5hUyq6UX7rrU6+uoloGwSkOrf70oyd4vM0BAIBFsV5+UQk/2VxZli8uR/al1W8+F41+aaravU5mLS+/MhKdmJjnmbAdxL9LWBSQwMzZl6d/jaYe/N6M4ysmKSFmy1lCX1k9hDTatTNYfmiNjY+1ZlLN4k/cXqp8l7yEORYlbl7vEZg/C9JlnCopG0QYY5h4582r/OxvUnjIaMJklqXOdm7gWiZQoL3VwY6PeHCKQ0rzqoJCn63/0kECAEBbbGtFOmNS2lEsioSHi99ONjd+xAz71IqRuNxeqnKPUyYraWKn3pp/RCbXk873m7jJ8XVyTZgsQXXB9guIJH05hxoiBEVBeHDALKb4eoEJKcv1czsbHzee/7/h5D7dbjt/RWo4RPp86eWrp7Ul5e8hnSGp6IAkMzpHGm1MW1rRmO5846Yf9LuF8Gaavg5U+QU+Ve7WI/RJ18ymXhXSs+Xzz0oTY7cbMM8fAFGgcWz5KQAApDcugEodRCrVN1RJ2ZXCD4/5M/n4C3laDh5fq9iMAAAAAElFTkSuQmCC" />
                      <img class="priority" *ngIf="item.priority === 'Baixa' "
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAYAAAAYl8YPAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wUVDS4GGZ/UGwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAI1SURBVDjLY/z//z8DLrDi8CrB1RfXLf3+76cnJxP79lD9oOgI27D3uNQzMeABe2/tT73x5Z7nw29PGW58uee57/bBVHzq8Rr2n4FBGZn/7/8/ZbINIxWMGjZqGD0MY1l7fD37rmt7IxkY/jNI8UstrQ+p/k2s5qm7ZnCfe3g+iouV6ysXL/dKliVnV6y89eW+PwMDA4PcF8mEunXNXk1Btd8IGbThxEbJw3eO7r386aYmAwMDg8R7USumx9+f+cMUPPr+3P7ko9Pbq1fXc+MzaP2JjZIrzq3ZDzOIgYGBQZhdMJFJllPqMrLCJz9e2J16enZ72coqrAauPbZeauW5NQcuf7qpjiz+48+Pw0z+mt7Bqtzyj5Elnv14ZXv22cUdjIyMPMji/Ox8UqsvrDtw+dNNNWRxcXbhS5ri6rGM////Z1iwd5HK1hs7Dlz7fEcaWZEgK9//978/McL47ExsDD///WJAM+iiqaSRS2dE6xtGWEm7YO8i5W03dh68+vm2NLGxKc4ufMFY0tC1O6LtDQMDAwMLTCLBOe4uAwODHeMNxoNXPt+SIWyQyHljSQPX7oi2t/B0hqwgwTnuHgMDgx3DTcZDVz7dxGmgBLvIOSMJfTdkgzAMgxp4n4GBwZbxJsOhy59uymLx2lkjCX237sj2dxg5AJvNCc5xDxgYGGwZbjIcRjZQnF3kDNQgrDUUCy6vJDjHPfzP8N+G4SbDqpc/35gLsQnslheUC+/BYRADAwMDADe82hf3OKHAAAAAAElFTkSuQmCC" />
                      <img class="priority" *ngIf="item.priority === 'Alta'"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAYAAAAYl8YPAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wUVDSYi7UW6wgAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAH2SURBVDjL7dPNSxtBFADwN5ORlHWtk9ZDQbsb1INRKy00OUqEbTAEQfFQ9ObNc/+BmMS/ItBiFAM9eCi0HlRiNklvpb0ESQpFROInknVNMN0NO14kuFt3CV568d2GefPjfTCIMQZ2cZVOC383N1OgaUHU1bXt6u19T+Pxql0+ssOu1tdFTZbzxv7+y1YypT/I8HCIxmL3gtgG8mrZrAkCAGCK8ra5t7etRKPP2qpMXVvz6rKcNw4O+mzbofQnGRkJ0aWlC1tMXVnx6oWCI3QH/EVGR9/RaPTinzbV1dV+PZdrC7pt+U2zWNxRYrEeE6amUv3a7m7WODw0Qaiz0zwDQqzg62axuKPE4z0AAK4PAwODWiaTZZWKadiou7uARfE7Ozt71bL8/q9ACGKXl89biY3GC6aqk1q5vIH1TGaDVSp9FijvGhqaBICaqZJ6/cgdDgexKP62VDjWLJVS2Dg9HbNAOeLzhT3Ly/X7ZsXPzh65I5EgFoSy6R3HBTHyeL7c2ZBMfL4wTSTqTsPnZ2aO3VNTE1gQSq3qqtVPhFtYmGtsbc0DADwJhdKcJF23s01+evrYODnx6zw/jwipIYDPhJOka06SPsID4uniYg0Ako7f6aHxiD1i/x9D6I/j2RLE6bIjEEga5+fjYBgRwPhbRyCQdMq/ASFjz1iASZW5AAAAAElFTkSuQmCC" />
                      <img class="priority" *ngIf="item.priority === 'Critica' "
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wUVDDcf5za/9AAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAHPSURBVDjL5VTNSxtBHH0zu/EjiZiDIeDFLiLZbVhyqCBBpZu1stCcBO+CgmfxnkP+BA+Sq3gQixcFFaMHD2KkEmO+WlLsoYIgWKmSmoSKmelBV2qcqPRU6IMfPB7vMW9+AwPOOern08REOOP3n2Y07SRvGG9EnkdCcWoqfKgoV2mApwF+6PP9yIVCwSeDnycnBzLBYMUO3Y/Hc5YPhx+EKe7wNRZ7e51MbrBsthX1uLz03uTzW9neXtWWKAB8mZ4OlZeXV1mh4EID8PNzLzs+3i4MDb0GAGnM6ewvJxIJdnDgBgDq9185Bgf3asXiKwBwRCJJXq16USrJqFTc7OJi5GxxcYWW5uc/sP19NwCQrq6fsq6/AyEp+yTS1LTnGh8fJap6fVe7k7S1rVNIkgsAiKKUWwwjElha+lhfsycWW2s2jBHS3X0brtWclPp8wzQQmJE1rV+dm9tpdEctHl9vsSyT6voMkaT3sr65mQKQwgugzs7uAti93+rf4L8N0vb2byL+J2SR2GFZ8e/VKrG5yEM45//Ico6i0b6jaLSvYVL0n+RM00pTytOU8pxpWiKPeKsezzAYAxi75S+uytgvIX/uORyKsnCj62M2F3l+A2ItCaDTEnVXAAAAAElFTkSuQmCC" />

                      <p matTooltip="{{item.priority !== null ? item.priority : 'Sem prioridade definida'}}"
                        matTooltipPosition="above">
                        {{item.priority !== null ? item.priority : "Sem prioridade definida"}}</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="info">
                    <p class="title">STATUS</p>
                    <div>
                      <p matTooltip="{{item.listName !== null ? item.listName : 'Lista sem nome'}}"
                        matTooltipPosition="above">{{item.listName !== null ? item.listName : "Lista sem nome"}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="info-row">
                <div>
                  <div class="info">
                    <p class="title">RESPONSÁVEL</p>
                    <div matTooltip="{{item.responsible !== null ? item.responsible : 'Sem responsável'}}"
                      matTooltipPosition="above">
                      <div class="avatar">{{item.avatar}}</div>
                      <p>{{item.responsible !== null ? item.responsible : "Sem responsável"}}</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="info">
                    <p class="title">REQUISITANTE</p>
                    <div matTooltip="{{item.requester !== null ? item.requester : 'Sem requisitante'}}"
                      matTooltipPosition="above">
                      <div class="avatar">{{item.requesterAvatar}}</div>
                      <p>{{item.requester !== null ? item.requester : "Sem requisitante"}}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="info" *ngIf="item.showExtendedItens">
                <p class="title">DESCRIÇÃO</p>
                <div>
                  <p *ngIf="item.description === undefined">Nenhuma descrição</p>
                  <p class="description-content" *ngIf="item.description !== undefined"
                    [innerHtml]="item.description | safeHtml"></p>
                </div>
              </div>
              <div class="info" *ngIf="item.showExtendedItens">
                <p class="title">COMENTÁRIOS</p>
                <div class="comment">
                  <p *ngIf="item.coments.length === 0">Nenhum comentário</p>
                  <div *ngFor="let coment of item.coments">
                    <div class="user">
                      <h6>{{coment.userName}}</h6>
                      <p style="margin-right: 5px;">{{coment.data | date:'dd/MM/yyyy'}} às
                        {{coment.data | date:'HH:mm'}}</p>
                    </div>
                    <p class="comment-content" [innerHtml]="coment.mensagem | safeHtml"></p>
                  </div>
                </div>
              </div>
            </div>
          </article>
          <div *ngIf="asideInformation.length === 0" class="empty">
            <i class="fas fa-exclamation-circle mr-1"></i>
            <p>A pesquisa não corresponde a nenhum registro!</p>
          </div>
        </div>
        <div [ngStyle]="statusNotificacoes ? {'display': 'block'} : {'display': 'none'}"
          [ngClass]="{'fade-in': 'statusNotificacoes'}">
          <h2>notificações</h2>
        </div>
      </aside>
    </div>
  </div>

  <!-- modal
<hr>
<pre>{{closeResult}}</pre>-->
  <!-- .modal cartão-->
  <ng-template #content let-modal let-d="dismiss">
    <div class="modal-header">
      <div class="window-header mod-card-detail-icons-smaller">
        <span class="window-header-icon icon-lg icon-card"><i class="d-block fas fa-chalkboard"></i></span>
        <div class="window-title">
          <h2 class="card-detail-title-assist"> {{ textTitulo.toUpperCase() }} </h2>
          <div class="window-header-inline-content quiet">
            <p class="u-inline-block u-bottom">na lista <a style="cursor: text;" href="javascript:void(0)"
                class="js-open-move-from-header">{{indexCurrentPainel.name}}</a></p>
          </div>
        </div>
      </div>
      <div ngbDropdown class="div-menu-modal">
        <button class="btn-menu btn btn-default" ngbDropdownToggle><i class="material-icons">more_horiz</i></button>
        <div ngbDropdownMenu [class.dropdown-menu-left]="isRTL">
          <a class="dropdown-item" [class.disabled]="(userAdm&&indexCurrentPainel.aprovador===null)?false:true"
            href="javascript:void(0)" (click)="openModalDefinirAprovadorCard()">{{ ((indexCurrentCard.aprovador===null)
            ?
            'Definir aprovador do cartão' : 'Aprovador: ' + indexCurrentCard.aprovadorNome) }}</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="openModalCheckBoxImpressao()">Imprimir cartão</a>
          <a class="dropdown-item" [class.disabled]="(listas.length>1)?null:true" href="javascript:void(0)"
            (click)="moveAll=false;openModalMoverCards(indexCurrentPainel)">Mover cartão</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="cardClone()">Clonar cartão</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="openModalSeguirCard()">{{'Seguir cartão'}}</a>
          <a class="dropdown-item" [class.disabled]="userAdm?null:true" href="javascript:void(0)"
            (click)="arquivarCard()">Arquivar cartão</a>
          <a class="dropdown-item" [class.disabled]="userAdm?null:true" href="javascript:void(0)"
            (click)="deleteCard()">Excluir cartão</a>
        </div>
      </div>
      <button type="button" class="close" aria-label="Close" (click)="onClosed()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">

      <!-- body -->
      <!--left panel-->
      <div class="window-main-col mod-card-detail-icons-smaller">

        <!--       <div class="window-module">
          <dnd-native></dnd-native>
      </div>


      <div class="window-module">
          <div [froalaEditor]="optionsDragDrop" class="field card-back-description"
           id="froala-editor"
          (click)="dragDropChange(event)"
          autofocus>
          <h3>Click here to edit the content</h3>
<p>Drag the image above or the text block to insert them in the editor.</p>
        </div>
      </div>
    -->
        <!--
      <div class="window-module">
          <div class="center">
              <file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)"
              (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
                  <span></span>
              </file-drop>
              <div class="upload-table">
                  <table class="table">
                      <thead>
                          <tr>
                              <th>Name</th>
                          </tr>
                      </thead>
                      <tbody class="upload-name-style">
                          <tr *ngFor="let item of files; let i=index">
                              <td><strong>{{ item.relativePath }}</strong></td>
                          </tr>
                      </tbody>
                  </table>
              </div>

            </div>
      </div>
    -->

        <!--
        <div class="window-module">
            <file-drop dropZoneLabel="Drop files here"  (onFileDrop)="dropped($event)"
            (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
            </file-drop>
            <div class="upload-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Name</th>
                        </tr>
                    </thead>
                    <tbody class="upload-name-style">
                        <tr *ngFor="let item of files; let i=index">
                            <td><strong>{{ item.relativePath }}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      -->


        <!-- titulo-->
        <div class="window-module" style=" padding-left: 0; margin-bottom: 10px;">
          <div id="divTextAreaOne" class="window-module-title window-module-title-no-divider-one title-modal"
            (click)="textAreaOne(true);textAreaAdjust('textAreaOneSize');tituloCartao.focus();">
            <!-- <span _ngcontent-c10="" class="icon-description icon-lg window-module-title-icon"><i class="d-block fas fa-bars"></i></span>
            -->
            <h4>{{ textCartao }}</h4>
          </div>
          <div id="textAreaOne" class="card-detail-edit edit">
            <div class="form-row">
              <div class="form-group col-sm-12 mb-0">
                <textarea #tituloCartao class="form-control" (keyup)="textAreaAdjust('textAreaOneSize')"
                  id="textAreaOneSize" placeholder="Adicione um título para este cartão..." [(ngModel)]="textCartao"
                  autofocus></textarea>
                <button type="button" class="btn btn-xs btn-primary" (click)="textAreaOneSave();"><i
                    class="fas fa-check"></i> Salvar</button>
                <span (click)="textAreaOne(false)" style="padding:3px 3px;position:absolute;cursor:pointer;"><i
                    class="material-icons">clear</i></span>
              </div>
            </div>
          </div>
        </div>

        <!--/titulo-->

        <!--tools bar-->
        <!-- <div class="card-detail-data u-gutter"><div class="card-detail-item u-clearfix js-card-detail-members"><h3 class="card-detail-item-header mod-no-top-margin">Membros</h3><div class="js-card-detail-members-list"><div class="member js-member-on-card-menu" data-idmem="5a901e250d30a42cb223c546"><span class="member-initials" title="Gilson Kopper (gilsonkopper1)">GK</span><span id="undefined-avatar"></span><span class="member-gold-badge" title="Este membro tem Trello Gold."></span></div><a class="card-detail-item-add-button dark-hover js-details-edit-members"><span class="icon-sm icon-add"></span></a></div></div><div class="card-detail-item card-detail-item-labels u-clearfix js-card-detail-labels"><h3 class="card-detail-item-header">Etiquetas</h3><div class="u-clearfix js-card-detail-labels-list js-edit-label"><span class="card-label card-label-sky mod-card-detail mod-clickable" title="ERP">ERP</span><a class="card-detail-item-add-button dark-hover js-details-edit-labels"><span class="icon-sm icon-add"></span></a></div></div><div class="card-detail-item hide js-card-detail-due-date"><h3 class="card-detail-item-header">Data Entrega</h3><span class="card-detail-badge card-detail-due-date-badge js-card-detail-due-date-badge"><span class="card-detail-badge-due-date-complete-box js-card-detail-due-date-badge-complete"><span class="icon-sm icon-check card-detail-badge-due-date-complete-icon"></span></span> <span class="js-date-text card-detail-due-date-text"></span></span></div><div class="card-detail-item hide js-card-detail-votes"><h3 class="card-detail-item-header">Votos</h3><a class="card-detail-badge is-clickable js-card-detail-votes-badge js-show-votes" href="#"></a></div><div class="card-detail-item hide js-card-detail-age"><h3 class="card-detail-item-header">Última Atualização</h3><div class="card-detail-badge date mod-last-updated js-card-detail-age-badge"></div></div><div class="plugin-detail-badges js-plugin-badges"><div></div></div><div class="u-clearfix"></div></div> -->
        <div class="window-module">
          <div class="window-module-title window-module-title-no-divider">

            <div class="card-detail-data u-gutter">

              <div class="card-detail-item card-detail-item-labels u-clearfix">
                <!-- *ngIf="this.indexCurrentCard.flags.length>0"-->
                <h3 class="card-detail-item-header">Marcadores</h3>
                <div class="u-clearfix buug-sc">
                  <span matTooltip="Excluir Marcador!" *ngFor="let flag of indexCurrentCard.flags"
                    [ngStyle]="{'background-color':flag.corBg}" class="card-label mod-card-detail mod-clickable"
                    (click)="removeEtiqueta(flag);" title="{{flag.nome}}">{{flag.nome}}</span> <!-- for -->
                  <a class="card-detail-item-add-button dark-hover" matTooltip="Adicionar Marcadores"
                    (click)="openModalEtiquetas(content)">
                    <i class="fas fa-plus"></i>
                  </a>
                </div>
              </div>

            </div>

          </div>
        </div>
        <!--/tools bar-->

        <!-- accordion -->
        <div class="window-module" *ngIf="todoCard.rms.id > 0 || todoCard.pedido.id > 0 || todoCard.nfeFin.id > 0">
          <div class="row">
            <div class="col-sm-12">

              <p-accordion class="custom-tab"
                *ngIf="todoCard.rms.id > 0 || todoCard.pedido.id > 0 || todoCard.nfeFin.id > 0">
                <p-accordionTab *ngIf="todoCard.rms.id > 0" header="RMS">
                  <div class="form-row">
                    <div class="form-group col-sm-9">
                      <label>Titulo</label>
                      <input class="form-control" type="text" pInputText [disabled]="true"
                        [(ngModel)]="todoCard.rms.infos.titulo" />
                    </div>
                    <div class="form-group col-sm-3">
                      <label>Dt Entrega</label>
                      <input class="form-control" type="text" pInputText [disabled]="true"
                        [(ngModel)]="todoCard.rms.infos.dtEntrada" />
                    </div>
                  </div>
                </p-accordionTab>
                <p-accordionTab *ngIf="todoCard.nfeFin.id > 0" (click)="buscarInfoFinanceiro()" header="FINANCEIRO">

                  <div class="form-row">
                    <app-nfe-fin-edit *ngIf="buscarFinanceiro" userId="{{sessionService.loggedUser.id}}"
                      nfeFinId="{{todoCard.nfeFin.id}}"></app-nfe-fin-edit>
                  </div>

                </p-accordionTab>
                <p-accordionTab *ngIf="todoCard.pedido.id > 0" header="PEDIDO" (click)="buscarInfoPedido()">

                  <div class="form-row">
                    <app-pedido-edit *ngIf="buscarPedido" userId="{{sessionService.loggedUser.id}}"
                      pedidoId="{{todoCard.pedido.id}}"></app-pedido-edit>

                  </div>

                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
        </div>
        <!--/accordion -->

        <!--descrição-->

        <div class="window-module">
          <div class="row">
            <div class="col-sm-12">
              <h3 class="sub-title mb-0"><i class="fas fa-bars"></i> Descrição</h3>
            </div>
          </div>

          <div id="divTextAreaTwo"
            class="window-module-title window-module-title-no-divider window-module-title-no-divider-one border-dashed"
            (click)="textAreaTwo(true);textAreaAdjust('textAreaTwoSize');descricaoCartao.focus();">
            <!--<span class="icon-description icon-lg window-module-title-icon"><i class="d-block fas fa-bars"></i></span>  | translate-->
            <span *ngIf="textDescricao.length > 0" class="u-inline-block-descricao"
              [innerHtml]="textDescricao | safeHtml"></span>

            <span *ngIf="textDescricao.length === 0"><a class="card-detail-fake-text-area hide-on-edit"
                href="javascript:void(0)">Adicione uma descrição mais detalhada...</a></span>
          </div>

          <div id="textAreaTwo" class="card-detail-edit edit">
            <div class="form-row">
              <div class="form-group col-sm-12 mb-0 mt-2">
                <textarea #descricaoCartao class="form-control" [froalaEditor]="options"
                  (keyup)="textAreaAdjust('textAreaTwoSize')" id="textAreaTwoSize"
                  placeholder="Adicione uma descrição mais detalhada para este cartão..." [(ngModel)]="textDescricao"
                  autofocus></textarea>
                <button type="button" class="btn btn-xs btn-primary" (click)="textAreaTwoSave();"><i
                    class="fas fa-check"></i> Salvar</button>
                <span (click)="textAreaTwo(false)" style="padding:3px 3px;position:absolute;cursor:pointer;"><i
                    class="material-icons">clear</i></span>
              </div>
            </div>
          </div>
        </div>

        <!-- /descrição-->

        <!-- anexo -->
        <div class="window-module" *ngIf="indexCurrentCard.anexos.length > 0">
          <div class="row">
            <div class="col-sm-12">
              <h3 class="sub-title mb-0"><i class="fas fa-paperclip"></i> Anexos</h3>
            </div>
          </div>
          <div class="window-module-title window-module-title-no-divider">
            <!--DRAG AND DROP INI
          <div fxLayout="row" id="div2" style="border:2px dashed #ededed;height:100px;border-radius:9px;"
            dndDropzone
            [dndAllowExternal]="true"
            (dndDrop)="onDrop($event)">

            <div fxLayout="column"
                fxLayoutAlign="space-between"
                class="layout-padding">
            </div>

            <div fxFlex fxLayout="column"
              fxLayoutAlign="center center"
              class="scrollable">
              <span style="color: #b5b5b5;font-family: Lato;">
                  <i style="margin:0px 0px -32px -20px;" class="lnr d-block lnr-paperclip"></i>
                  Solte os arquivos aqui!
              </span>
            </div>

          </div>

          <!-
             (click)="openModalAnexo();"
            <div>
            <h5>Arquivos enviados</h5>
            <table>
                <ng-container *ngFor="let file of lastDropFiles">
                    <tr><td>Nome do arquivo : </td><td>{{file.name}}</td></tr>
                </ng-container>
              </table>
          </div>

          DRAG AND DROP FIM-->
            <table style="font-size: 11px; width: 100%; border-collapse: collapse;">
              <tr *ngFor="let file of indexCurrentCard.anexos">
                <td style="color:#8c8c8c;text-transform:initial;line-height:28px; padding: 4px;">
                  <span class="class-categoria-anexo"> {{ file.categoria.split(' - ')[1] }} </span>
                  <span class="u-inline-block" style="cursor:pointer; font-size: 10pt;" matTooltip='Baixar Arquivo!'
                    (click)="anexoBaixar(file)">
                    {{ file.nome }}
                  </span>
                </td>
                <td style="text-align:right;padding-right:5px;">
                  <span class="u-inline-block" matTooltip='Excluir Arquivo' (click)="anexoExcluir(file)"
                    class="botao-excluir-file">
                    <i class="d-block far fa-trash-alt"></i>
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <!--<div class="window-module">
          <textarea [froalaEditor]="optionsEditorAnexos" class="field card-back-description"
           id="textAreaTwoSize"
          (click)="anexoChange(event)"
          autofocus></textarea>
      </div>-->


        <!-- /anexo-->
        <!-- check list-->
        <div class="window-module checklist-list" *ngFor="let lst of indexCurrentCard.checkLists;let pos = index;">

          <div class="checklist">
            <div class="window-module-title window-module-title-no-divider">
              <div class="editable non-empty checklist-title sub-title" attr="name">
                <span class="icon-description icon-lg window-module-title-icon"><i
                    style="position: absolute; top: 10px; z-index: 10; font-weight:600;"
                    class="lnr d-block lnr-checkmark-circle"></i></span>
                <h3 class="u-inline-block title-body-buug editable-div mb-0" contenteditable="true"
                  id="checkList_{{ lst.id }}" (focusin)="onFocusInEditable()" (focusout)="onEditChklst(lst.id)">{{
                  lst.titulo }}</h3>

                <div class="window-module-title-options">
                  <a class="hide-on-edit btn btn-link p-0" style="text-decoration:underline;" href="javascript:void(0)"
                    (click)="checkListDelete(lst);" matTooltip='Excluir CheckList!'><i class="fas fa-times"
                      style="color: darkred;"></i> Deletar…</a>
                </div>
              </div>
            </div>
          </div>

          <label style="color:#8c8c8c;margin: 0 0 0 11px;">Evolução: {{lst.porcentagem}}%</label>

          <div class="window-module-title window-module-title-no-divider flex-check-list">
            <div class="flex">
              <div class="container" dragula="ATIVIDADES" [(dragulaModel)]="lst.checklistAtividades">
                <div class="vamp" *ngFor="let item of lst.checklistAtividades;let i = index;"
                  [attr.atividade-id]="item.id">
                  <div style="position:absolute;">
                    <p-checkbox [(ngModel)]="item.concluida" name="status{{i}}" (click)="checkListItemComplete(item)">
                    </p-checkbox>
                  </div>
                  <span id="atividade_{{item.id}}" class="{{ item.concluida ? 'item-concluido' : 'vazio' }}"
                    (click)="checkListItemEdit(item);textAreaAtivAdjust('textAreaAtiv_'+item.id);editChkLstAtiv.focus();">
                    {{ item.descricao }} </span>
                  <span id="atividadeText_{{item.id}}" style="display:none">
                    <div class="form-row">
                      <div class="form-group col-sm-12 mb-2">
                        <textarea class="form-control" (keyup)="textAreaAtivAdjust('textAreaAtiv_'+item.id)"
                          placeholder="Adicionar item..." (focusin)="hiddenOther(lst.id,999)"
                          id="textAreaAtiv_{{item.id}}" [(ngModel)]="checklistAtividade.descricao"
                          #editChkLstAtiv></textarea>
                        <button type="button" class="btn btn-xs btn-primary" (click)="checkListItemSave(lst);"
                          style="margin-left: 22px;"><i class="fas fa-check"></i> Salvar</button>
                        <span
                          (click)="componentShowHide('atividadeText_'+item.id,'atividade_'+item.id);startGetListas()"
                          style="padding:3px 3px;position:absolute;cursor:pointer;">
                          <i class="material-icons">clear</i>
                        </span>
                      </div>
                    </div>
                  </span>
                  <span (click)="checkListItemDelete(item);" class="botao-excluir" matTooltip='Excluir atividade!'><i
                      class="d-block far fa-trash-alt"></i></span>
                </div>
              </div>
            </div>

          </div>

          <div id="divTextAreaCheckList_{{lst.id}}"
            class="window-module-title window-module-title-no-divider window-module-title-no-divider-one"
            [ngStyle]="{'display':(displayTexAtiv[pos]?'block':'none')}"
            (click)="newAtividade();componentShowHide('textAreaCheckList_'+lst.id,'divTextAreaCheckList_'+lst.id);addChkLstAtiv.focus();displayTexAtiv[pos]=!displayTexAtiv[pos]">
            <span class="u-inline-block"></span>
            <span><a class="card-detail-fake-text-area-clk hide-on-edit " href="javascript:void(0)"
                (click)="stopGetListas()">Adicionar atividade... </a></span>
          </div>

          <div id="textAreaCheckList_{{lst.id}}" class="card-detail-edit edit-chk-ativ"
            [ngStyle]="{'display':(!displayTexAtiv[pos]?'block':'none')}"
            (mouseover)="addChkLstAtiv.focus();hiddenOther(lst.id,pos)">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <!--displayTexAtiv=!displayTexAtiv-->
                <textarea id="textAreaAtividade_{{lst.id}}" #addChkLstAtiv class="form-control d-block"
                  placeholder="Adicionar atividade..." (focusin)="hiddenOther(lst.id,pos)"
                  (keyup)="textAreaAtivAdjust('textAreaAtividade_'+lst.id);"
                  [(ngModel)]="checklistAtividade.descricao"></textarea>
                <button type="button" class="btn btn-xs btn-primary"
                  (click)="checkListItemSave(lst);addChkLstAtiv.focus();"><i class="fas fa-check"></i> Salvar</button>
                <span id="textAreaCloser"
                  (click)="newAtividade();componentShowHide('textAreaCheckList_'+lst.id,'divTextAreaCheckList_'+lst.id);displayTexAtiv[pos]=!displayTexAtiv[pos];startGetListas()"
                  style="padding:3px 3px;position:absolute;cursor:pointer;">
                  <i class="material-icons">clear</i>
                </span>
              </div>
            </div>
          </div>

        </div>
        <!-- /check list -->

        <!-- comentário insert-->
        <div class="window-module">
          <div class="row">
            <div class="col-sm-12">
              <h3 class="sub-title mb-0 mt-0"><i class="fas fa-bars"></i> Comentário</h3>
            </div>
          </div>

          <div id="divTextAreaThree"
            class="window-module-title window-module-title-no-divider  window-module-title-no-divider-one border-dashed"
            (click)="textAreaThree(true);textAreaAdjust('textAreaThreeSize');comentarioCartao.focus();">
            <span><a class="card-detail-fake-text-area hide-on-edit" href="javascript:void(0)">Adicionar comentário para
                este cartão...</a></span>
          </div>

          <div id="textAreaThree" class="card-detail-edit edit" style="margin-top: 10px;">
            <div class="form-row">
              <div class="form-group col-sm-12 mb-0 mt-2">
                <textarea #comentarioCartao [(ngModel)]="textComentario" [(froalaModel)]="textComentario"
                  id="textAreaThreeSize" class="form-control" (keyup)="textAreaAdjust('textAreaThreeSize')"
                  placeholder="Adicionar comentário para este cartão..." labelKey="label"
                  [froalaEditor]="options"></textarea>
                <button type="button" class="btn btn-xs btn-primary" (click)="textAreaThreeSave();"><i
                    class="fas fa-check"></i> Salvar</button>
                <span (click)="textAreaThree(false)" style="padding: 3px 3px;position:absolute;cursor:pointer;"><i
                    class="material-icons">clear</i></span>
              </div>
            </div>
          </div>


        </div>

        <!-- / comentário insert-->

        <!--
          Abas Todos/Comentario/Atividades
        -->
        <mat-tab-group>
          <mat-tab label="Comentários" class="mat-tab-labels" style="font-size: 13pt; font-weight: 600;">
            <!-- comentários -->
            <div class="window-module mt-2">
              <div class="mod-card-back">

                <div *ngFor="let comentario of indexCurrentCard.comentarios | slice:0:5; let i=index"
                  class="u-inline-block comentarios" [hidden]="showComentarios">
                  <span (click)="deleteComentario(comentario);" class="botao-excluir-comentarios"
                    matTooltip='Excluir comentário!'><i class="d-block far fa-trash-alt"></i></span>
                  <span (click)="textAreaThreeEdit(true, comentario);" class="botao-editar-comentario"
                    matTooltip='Editar comentário!'><i class="d-block fas fa-pencil-alt"></i></span>
                  <div class="comentario-cabecalho"> <b>{{ $any(comentario).userName }}</b>
                    {{ $any(comentario).data | date:'dd/MM/yyyy HH:mm:ss' }}</div>
                  <div class='comentarios-back-ground-grey' [innerHtml]="$any(comentario).mensagem | safeHtml">
                    <!--(click)="textAreaThreeEdit(true, comentario);" style="cursor:pointer;"  matTooltip='Editar comentário!'-->
                  </div>
                  <div class="window-module-title-options" style="text-align: right;"
                    *ngIf="i == 4 && !showComentarios">
                    <a class="hide-on-edit btn btn-link" style="text-decoration:underline;" href="javascript:void(0)"
                      (click)="showComentarios=!showComentarios"><i class="far fa-eye"></i> Mostrar comentários...</a>
                  </div>
                  <!--</span>>{{ comentario.mensagem }}-->
                </div>

                <div *ngFor="let comentario of indexCurrentCard.comentarios" class="u-inline-block comentarios"
                  [hidden]="!showComentarios">
                  <span (click)="deleteComentario(comentario);" class="botao-excluir-comentarios"
                    matTooltip='Excluir comentário!'><i class="d-block far fa-trash-alt"></i></span>
                  <span (click)="textAreaThreeEdit(true, comentario);" class="botao-editar-comentario"
                    matTooltip='Editar comentário!'><i class="d-block fas fa-pencil-alt"></i></span>
                  <div class="comentario-cabecalho"> <b>{{ comentario.userName }}</b>
                    {{ comentario.data | date:'dd/MM/yyyy HH:mm:ss' }}</div>
                  <div class='comentarios-back-ground-grey' [innerHtml]="comentario.mensagem | safeHtml">
                    <!--(click)="textAreaThreeEdit(true, comentario);" style="cursor:pointer;"  matTooltip='Editar comentário!'-->
                  </div>
                </div>

                <div class="window-module-title-options" style="text-align: right;" *ngIf="showComentarios">
                  <a class="hide-on-edit btn btn-link" style="text-decoration:underline;" href="javascript:void(0)"
                    (click)="showComentarios=!showComentarios"><i class="far fa-eye-slash"></i> Ocultar
                    comentários...</a>
                </div>

                <div class="alert alert-xs alert-primary d-inline-block"
                  *ngIf="indexCurrentCard.comentarios.length === 0"><i class="fas fa-info-circle"></i> Sem comentários
                </div>

              </div>
            </div>
            <!-- / comentários -->
          </mat-tab>
          <mat-tab label="Atividades" style="font-size: 13pt; font-weight: 600;">
            <!-- actions -->
            <div class="window-module mt-2">
              <div class="mod-card-back">

                <div *ngFor="let action of indexCurrentCard.actions | slice:0:5; let i=index"
                  class="u-inline-block atividades" [hidden]="showActions">
                  <div> <b>{{ $any(action).userName }}</b> em {{ $any(action).data | date:'dd/MM/yyyy HH:mm:ss' }}<br>
                    <span class="atividades-formata-text" [innerHtml]="$any(action).mensagem | safeHtml"> </span>
                  </div>
                  <div class="window-module-title-options" style="text-align: right;" *ngIf="i == 4 && !showActions">
                    <a class="hide-on-edit btn btn-link" style="text-decoration:underline;" href="javascript:void(0)"
                      (click)="showActions=!showActions"><i class="far fa-eye"></i> Mostrar atividades...</a>
                  </div>
                </div>

                <div *ngFor="let action of indexCurrentCard.actions" class="u-inline-block atividades"
                  [hidden]="!showActions">
                  <div> <b>{{ action.userName }}</b> em {{ action.data | date:'dd/MM/yyyy HH:mm:ss' }}<br>
                    <span class="atividades-formata-text" [innerHtml]="action.mensagem | safeHtml"> </span>
                  </div>
                </div>

                <div class="window-module-title-options" style="text-align: right;" *ngIf="showActions">
                  <a class="hide-on-edit btn btn-link " style="text-decoration:underline;" href="javascript:void(0)"
                    (click)="showActions=!showActions"><i class="far fa-eye-slash"></i> Ocultar atividades...</a>
                </div>

                <div class="alert alert-xs alert-primary d-inline-block"
                  *ngIf="showActions&&indexCurrentCard.actions.length === 0"><i class="fas fa-info-circle"></i> Sem
                  atividades</div>

              </div>

              <!-- <div class="window-module-title window-module-title-no-divider"> -->

              <!-- </div> -->
            </div>
          </mat-tab>
          <mat-tab label="Aprovações" style="font-size: 13pt; font-weight: 600;">
            <!-- actions -->
            <div class="window-module mt-2">
              <div class="mod-card-back">

                <div *ngFor="let action of indexCurrentCard.aprovs | slice:0:5; let i=index"
                  class="u-inline-block atividades" [hidden]="showAprovs">
                  <div> <b>{{ $any(action).userName }}</b> em {{ $any(action).data | date:'dd/MM/yyyy HH:mm:ss' }}<br>
                    <span class="atividades-formata-text" [innerHtml]="$any(action).mensagem | safeHtml"> </span>
                  </div>
                  <div class="window-module-title-options" style="text-align: right;" *ngIf="i == 4 && !showAprovs">
                    <a class="hide-on-edit btn btn-link" style="text-decoration:underline;" href="javascript:void(0)"
                      (click)="showAprovs=!showAprovs"><i class="far fa-eye"></i> Mostrar aprovações...</a>
                  </div>
                </div>

                <div *ngFor="let action of indexCurrentCard.aprovs" class="u-inline-block atividades"
                  [hidden]="!showAprovs">
                  <div> <b>{{ action.userName }}</b> em {{ action.data | date:'dd/MM/yyyy HH:mm:ss' }}<br>
                    <span class="atividades-formata-text" [innerHtml]="action.mensagem | safeHtml"> </span>
                  </div>
                </div>

                <div class="window-module-title-options" style="text-align: right;" *ngIf="showAprovs">
                  <a class="hide-on-edit btn btn-link" style="text-decoration:underline;" href="javascript:void(0)"
                    (click)="showAprovs=!showAprovs"><i class="far fa-eye-slash"></i> Ocultar aprovações...</a>
                </div>

                <div class="alert alert-xs alert-primary d-inline-block"
                  *ngIf="showAprovs&&indexCurrentCard.aprovs.length === 0"><i class="fas fa-info-circle"></i> Sem
                  Aprovações</div>

              </div>

              <!-- <div class="window-module-title window-module-title-no-divider"> -->

              <!-- </div> -->
            </div>

            <!-- / actions -->
          </mat-tab>

        </mat-tab-group>

      </div>
      <!--sidebar-->
      <div class="window-sidebar">
        <!--Texto Adicionar ao cartão-->
        <h3 class="mod-no-top-margin">Adicionar ao cartão</h3>

        <!--Assinar cartão-->
        <div class="window-module u-clearfix">
          <a class="button-link aprov" href="javascript:void(0)"
            [class.disabled]="(indexCurrentPainel.id < listas.length && (indexCurrentPainel.aprovador === sessionService.loggedUser.id || indexCurrentCard.aprovador === sessionService.loggedUser.id))? null:true"
            (click)="onClosed();assinarCard(indexCurrentCard)">
            <span class="icon-sm icon-member"><i class="far fa-check-square"></i></span>
            <span> Aprovar</span>
          </a>
        </div>

        <!--Prioridade-->
        <div class="window-module u-clearfix">
          <a class="button-link" href="javascript:void(0)" (click)="openModalPrioridade(content)">
            <span class="icon-sm icon-member"><i class="lnr d-block lnr-arrow-up-circle"></i></span>
            <span> Prioridade</span>
          </a>
        </div>

        <!--regra-->
        <div class="window-module u-clearfix">
          <a class="button-link" href="javascript:void(0)" (click)="openModalStatus()">
            <span style="font-size: 12px;" class="icon-sm icon-member"><i class="lnr d-block lnr-tag"></i></span>
            <span> {{ ((indexCurrentCard.alcada===null) ? 'Regra' : 'Regra: ' + indexCurrentCard.alcadaNome) }}</span>
          </a>
        </div>

        <!--checklist-->
        <div class="window-module u-clearfix">
          <a class="button-link" href="javascript:void(0)" (click)="openModalCl(content);">
            <span class="icon-sm icon-member"><i class="lnr d-block lnr-checkmark-circle"></i>
              <!--<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAIAAAD9iXMrAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADkSURBVChTdZHfC8FQHMX3byuFIqVQfrYWy/yIQkmUJ3mQ4kEotohQa6WRZPZDzdGY2Tidh91zPvd7u3eEruuXqySezj+NCgBEjOdLd5RyhUmnw9ny4Xh6cc1u3xPLDKcL2yRYUVVwyWJ9wq6eXCDNIDX2WSUcxBBV8sZpbr37y1khLD/cTVY07e6EpJvMbd7ztrwQoSsxpoobWiFZUbO1FpjPvNGMxYVABMm8eRxytF8cUgM1ob8ctN7zONf4hr44fypnvqdNyNE+uXZvgKf3JWjscxo5WjAE/mCh0bHVVqO9XKUHyIuSJqEake0AAAAASUVORK5CYII="> -->
            </span>
            <span> Check List</span>
          </a>
        </div>

        <!--Requisitante-->
        <div class="window-module u-clearfix">
          <a class="button-link" href="javascript:void(0)" (click)="openModalRequisitante(content)">
            <span style="font-size: 12px;" class="icon-sm icon-member">
              <i class="lnr d-block lnr-user"></i>
            </span>
            <!--<i class="fas fa-user-plus">-->
            <span> Requisitante</span>
          </a>
        </div>

        <!--Responsável-->
        <div class="window-module u-clearfix">
          <a class="button-link" href="javascript:void(0)" (click)="openModalResponsavel(content)">
            <span style="font-size: 12px;" class="icon-sm icon-member"><i class="lnr d-block lnr-user"></i></span>
            <!---->
            <span> Responsável</span>
          </a>
        </div>

        <!--Participantes-->
        <div class="window-module u-clearfix">
          <a class="button-link" href="javascript:void(0)" (click)="openModalParticipante(content)">
            <span style="font-size: 16px;" class="icon-sm icon-member"><i class="lnr d-block lnr-users"></i></span>
            <!--<i class="fas fa-user-plus"></i>-->
            <span> Add Participantes</span>
          </a>
        </div>

        <!--Prazo-->
        <div class="window-module u-clearfix">
          <a class="button-link" href="javascript:void(0)" (click)="openModalPrazo(content)">
            <span class="icon-sm icon-member"><i class="lnr d-block lnr-calendar-full"></i></span>
            <span> Prazo</span>
          </a>
        </div>

        <!--anexo-->
        <div class="window-module u-clearfix">
          <a class="button-link" href="javascript:void(0)" (click)="openModalDrop();">
            <span for="file-upload" style="font-size: 16px;" class="icon-sm icon-member"><i
                class="lnr d-block lnr-paperclip"></i></span>
            <span> Anexos</span>
          </a>
        </div>

        <!--Upload-->
        <div class="window-module u-clearfix" *ngIf="categoriaId  || categoriaNome === 'SemCateg0ri4'">
          <div class="card-detail-data u-gutter">
            <div class="card-detail-item u-clearfix" style="margin-bottom: 20px;">
              <!--<h3 class="card-detail-item-header mod-no-top-margin">Upload de Arquivos</h3>-->
              <div class="u-clearfix buug-sc">
                <!--<a class="card-detail-item-add-button dark-hover" matTooltip="Selecionar Categoria" (click)="openModalDrop()">
                <i class="fas fa-plus"></i>
              </a> -->
                <span *ngIf="categoriaId===null" style="font-size:10pt;color:#6b808c;font-family:Lato;">Sem
                  categoria</span>
                <span *ngIf="categoriaId!==null" style="font-size:10pt;color:#6b808c;font-family:Lato;">Categoria:
                  {{categoriaNome}}</span>
                <div fxLayout="row" id="div2"
                  style="border:2px dashed #ededed;height:150px;border-radius:9px;margin-top:6px;font-size:14px;width:163px;"
                  [dndDropzone]="[]" [dndAllowExternal]="true" (dndDrop)="onDrop($event)">
                  <div fxLayout="column" fxLayoutAlign="space-between" class="layout-padding">
                  </div>
                  <div fxFlex (click)="openAnexoSelect();" fxLayout="column" fxLayoutAlign="center center"
                    class="scrollable" style="cursor: pointer;">
                    <span style="color: #b5b5b5;font-family: Lato; text-align: center;">
                      <i class="lnr d-block lnr-paperclip"></i>
                      Solte os arquivos<br>ou, clique aqui!
                    </span>
                  </div>
                </div>
                <div *ngIf="enableInput" style="display:none" class="input-12" input-vertical="middle">
                  <input id="file-upload" type="file" (change)="anexoChange($event);" #file />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--/Upload-->

        <!--Data Entrega-->
        <div class="window-module u-clearfix mt-3">
          <div class="card-detail-item {{ indexCurrentCard.dataFim !== null ? '' : 'hide' }}">
            <h3 class="card-detail-item-header">Data Entrega </h3>
            <span [ngClass]="(currentDate >= indexCurrentCard.dataFim) ? 'is-due-incomplete': 'is-due-complete'"
              class="card-detail-badge card-detail-due-date-badge">
              <span class="card-detail-due-date-text" matTooltip="Remover Data!"
                (click)="remDataFimCard()">{{indexCurrentCard.dataFim | date:'dd/MM/yyyy'}}</span>
            </span>
          </div>
        </div>
        <!--/Data Entrega-->

        <!--Data Criado-->
        <div class="window-module u-clearfix">
          <div class="card-detail-item">
            <h3 class="card-detail-item-header">Criado em </h3>
            <span class="card-detail-badge card-detail-due-date-badge" style="cursor:default;margin-bottom:20px;">
              <span class="" style="font-size:9pt;font-weight:600;padding:0 12px;;">{{indexCurrentCard.dataCriado |
                date:'dd/MM/yyyy'}}
                às {{indexCurrentCard.dataCriado | date:'HH:mm'}}</span>
            </span>
          </div>
        </div>
        <!--/Data Criado-->

        <!--Participantes-->
        <div class="window-module u-clearfix" *ngIf="indexCurrentCard.participantes.length>0">
          <div class="card-detail-data u-gutter">
            <div class="card-detail-item u-clearfix">
              <h3 class="card-detail-item-header mod-no-top-margin">Participantes</h3>
              <div class="u-clearfix buug-sc" matTooltip="Remover Participante!">
                <!-- <a class="card-detail-item-add-button dark-hover" matTooltip="Add Participante" (click)="openModalParticipante(content)">
                <i class="fas fa-plus"></i>
              </a> -->
                <div class="member" *ngFor="let part of indexCurrentCard.participantes"
                  (click)="removeParticipante(part)">
                  <span class="member-initials" title="{{part.responsavel}}">{{part.avatar}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--/Participantes-->

      </div>
    </div>
    <!--/sidebar-->

    <div class="ui-g" style="position: fixed; right: 15px;  bottom: 5px; max-width: 500px;">
      <div class="ui-g-12">
        <p-messages [value]="msgsModal" (click)="hideMessage()"></p-messages>
      </div>
    </div>
    <!-- /body -->

    <!-- .modal checkBox impressão (FEITO) -->
    <div class="backdrop" [ngStyle]="{'display':displayCheckBoxImpressao}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayCheckBoxImpressao}"
      style="left: inherit; right: 7.3%; top: 12px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close"
              (click)="onCloseHandled();startGetListas()"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title modal-title-checklist">Imprimir Cartão</h4>
          </div>
          <div class="modal-body modal-body-checklist">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <p-checkbox class="d-block mb-1" id="cbcoment" [binary]="true" [(ngModel)]="ocultarComents">Ocultar
                  comentários
                </p-checkbox>
                <p-checkbox class="d-block" [binary]="true" [(ngModel)]="ocultarAtiv">Ocultar atividades</p-checkbox>
              </div>
            </div>
          </div>
          <div class="modal-footer modal-footer-checklist">
            <button type="button" class="btn btn-sm btn-secondary"
              (click)="onCloseHandled();startGetListas();ocultarAtiv=false;ocultarComents=false"><i
                class="fas fa-undo"></i> Cancelar</button>
            <button type="button" class="btn btn-sm btn-primary" (click)="imprimirCartao()"><i class="fas fa-print"></i>
              Imprimir</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal checklist!-->

    <!-- .modal-content checklist (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayCLModal}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayCLModal}"
      style="left: inherit; right: 1.7%; top: 211px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close"
              (click)="onCloseHandled();startGetListas()"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title modal-title-checklist">Adicionar Checklist</h4>
          </div>
          <div class="modal-body modal-body-etiquetas">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label for="chlst-title">Título</label>
                <input id="chlst-title" type="text" class="form-control" [(ngModel)]="checkList.titulo" />
              </div>
            </div>
          </div>
          <div class="modal-footer modal-footer-checklist">
            <button type="button" class="btn btn-sm btn-secondary" (click)="onCloseHandled();startGetListas()"><i
                class="fas fa-undo"></i> Cancelar</button>
            <button type="button" class="btn btn-sm btn-primary" (click)="onSaveChklst()"><i class="fas fa-check"></i>
              Salvar</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal checklist!-->

    <!-- .modal-content Marcadores (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayEtiqModal}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayEtiqModal}"
      style="left: 25px; right: inherit; top: 166px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()"><span
                aria-hidden="true">&times;</span></button>
            <h4 class="modal-title modal-title-etiquetas"> Marcadores</h4>
          </div>
          <div class="modal-body">
            <div class="form-row" *ngIf="etiquetas.length>0">
              <div class="form-group col-sm-12">
                <div class="list-group" style="color:#ffffff;">
                  <a class="list-group-item list-group-item-action" *ngFor="let etiqueta of etiquetas"
                    (click)="setEtiquetaCard(etiqueta);" [ngStyle]="{'background-color':etiqueta.corBg}"
                    style="cursor:pointer;border-radius:0.25rem; padding: 5px 10px; font-size: 15px;">
                    {{ etiqueta.nome}}
                  </a>
                </div>
              </div>
            </div>
            <div class="form-row" *ngIf="etiquetas.length===0">
              <div class="form-group col-sm-12">
                <div class="alert alert-xs alert-primary">
                  <i class="fas fa-info-circle"></i> Sem Marcadores
                </div>
              </div>
            </div>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal Marcadores!-->

    <!-- .modal Participante (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayPartModal}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayPartModal}"
      style="left: inherit; right: 1.7%; top: 331px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title modal-title-etiquetas"> Participantes</h4>
          </div>
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <div class="list-group" *ngIf="participantes.length>0">
                  <a class="list-group-item list-group-item-action" style="cursor:pointer;padding:.35rem .9375rem;"
                    *ngFor="let part of participantes" (click)="setParticipanteCard(part);"> {{ part.usuario.fullName }}
                  </a>
                </div>
                <div class="alert alert-xs alert-primary" *ngIf="participantes.length===0">
                  <i class="fas fa-info-circle"></i> Sem participantes
                </div>
              </div>
            </div>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal Participante!-->

    <!-- .modal prazo (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayPrazoModal}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayPrazoModal}"
      style="left: inherit; right: 1.7%; top: 371px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title modal-title-etiquetas"> Prazo</h4>
          </div>
          <div class="modal-body">
            <div class="form-row">
              <p-calendar dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                [defaultDate]="newDataFim" yearRange="2010:2030" class="type-p-calendar" [(ngModel)]="newDataFim"
                [showIcon]="true">
              </p-calendar>
            </div>
            <!--<ng-template #footerTemplate>
            <hr class="my-0">
            <button class="btn btn-primary btn-sm m-2 float-left" (click)="model = today; d.close()">Hoje</button>
            <button class="btn btn-secondary btn-sm m-2 float-right" (click)="d.close()">Fechar</button>
          </ng-template>-->
          </div>
          <div class="modal-footer modal-footer-checklist">
            <button type="button" class="btn btn-sm btn-secondary" (click)="onCloseHandled()"><i
                class="fas fa-undo"></i>
              Cancelar</button>
            <button type="button" class="btn btn-sm btn-primary" (click)="setDataFimCard()"><i class="fas fa-check"></i>
              Salvar</button>
          </div>
        </div><!-- /.modal-content https://ng-bootstrap.github.io/#/components/datepicker/examples-->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal prazo!-->

    <!-- .modal Prioridade (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayPrioridadeModal}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayPrioridadeModal}"
      style="left: inherit;right: 1.7%;top: 131px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title modal-title-etiquetas"> Prioridade</h4>
          </div>
          <div class="modal-body modal-body-etiquetas">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <!-- <div class="list-group">
                  <span class="list-group-item">{{todoCard.usuario.fullName}}</span>
              </div> -->
                <label>Selecione</label>
                <p-dropdown class="type-p-dropdown" [(ngModel)]="todoCard.prioridade.id" [options]="listaPrioridade"
                  defaultLabel="Selecione" [filter]="true"></p-dropdown>
              </div>
            </div>
          </div>
          <div class="modal-footer modal-footer-checklist">
            <button type="button" class="btn btn-sm btn-secondary" (click)="onCloseHandled()"><i
                class="fas fa-undo"></i>
              Cancelar</button>
            <button type="button" class="btn btn-sm btn-primary" (click)="alterarPrioridade()"><i
                class="fas fa-check"></i> Salvar</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal Prioridade!-->

    <!-- .modal Requisitante (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayModalReq}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayModalReq}"
      style="left: inherit; right: 1.7%; top: 251px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title modal-title-etiquetas"> Requisitante</h4>
          </div>
          <div class="modal-body modal-body-etiquetas">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <!-- <div class="list-group">
                  <span class="list-group-item">{{todoCard.usuario.fullName}}</span>
              </div> -->
                <label>Selecione</label>
                <p-dropdown class="type-p-dropdown" [(ngModel)]="todoCard.usuario.id" [options]="usuariosList"
                  defaultLabel="Selecione" [filter]="true"></p-dropdown>
              </div>
            </div>
          </div>
          <div class="modal-footer modal-footer-checklist">
            <button type="button" class="btn btn-sm btn-secondary" (click)="onCloseHandled()"><i
                class="fas fa-undo"></i>
              Cancelar</button>
            <button type="button" class="btn btn-sm btn-primary" (click)="alterarRequisitante()"><i
                class="fas fa-check"></i> Salvar</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal Requisitante!-->

    <!-- .modal Responsável (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayModalResp}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayModalResp}"
      style="left: inherit; right: 1.7%; top: 291px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title modal-title-etiquetas"> Responsável</h4>
          </div>
          <div class="modal-body modal-body-etiquetas">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label>Selecione</label>
                <p-dropdown class="type-p-dropdown" [(ngModel)]="todoCard.responsavel.id" [options]="usuariosList"
                  defaultLabel="Selecione" [filter]="true"></p-dropdown>
              </div>
              <!-- NÃO EXCLUIR - GCK - 09.01
                <div class="lks-form-grid">
                  <div input-text="right" input-vertical="middle">
                    <label>Responsável Substituto:</label>
                  </div>
                  <div class="input-12 type-p-dropdown" input-vertical="middle" >
                  <p-dropdown [(ngModel)]="todoCard.responsavelSub.id"
                    [options]="usuariosList"
                    defaultLabel="Selecione"
                    [filter]="true"></p-dropdown>
                  </div>
                </div>
                -->
            </div>
          </div>
          <div class="modal-footer modal-footer-checklist">
            <button type="button" class="btn btn-sm btn-secondary" (click)="onCloseHandled()"><i
                class="fas fa-undo"></i>
              Cancelar</button>
            <button type="button" class="btn btn-sm btn-primary" (click)="alterarResponsavel()"><i
                class="fas fa-check"></i> Salvar</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal Responsável!-->

    <!-- .modal mover cards (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayMoverCardsModal}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayMoverCardsModal}"
      style="left: inherit; right: 7.3%; top: 12px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()"><span
                aria-hidden="true">&times;</span></button>
            <h4 class="modal-title modal-title-etiquetas">Mover {{moveAll?'todos os cartões':'cartão'}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <div class="list-group">
                  <a class="list-group-item list-group-item-action" style="cursor:pointer;padding:.3rem .6rem;"
                    *ngFor="let list of listMoverCards"
                    (click)="moveAll?moveAllCards(list):moveCard(list);displayMoverCardsModal='none';displayMoverCardsList='none'">
                    {{ list.name }} </a>
                </div>
              </div>
            </div>
            <div class="form-row" *ngIf="listas.length===0">
              <div class="form-group col-sm-12">
                <div class="alert alert-xs alert-primary">
                  <i class="fas fa-info-circle"></i> Sem painel
                </div>
              </div>
            </div>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal mover cards!-->

    <!-- .modal seguir card (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displaySeguirCardModal}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displaySeguirCardModal}"
      style="left: inherit; right: 7.3%; top: 12px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()"><span
                aria-hidden="true">&times;</span></button>
            <h4 class="modal-title modal-title-etiquetas">{{segCard === []? 'Seguir cartão' : 'Seguindo'}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label>Tipo</label>
                <p-multiSelect class="type-p-mult" [ngModelOptions]="{standalone: true}" [(ngModel)]="segCard"
                  [options]="seguirCardList" defaultLabel="Selecione" [filter]="true"
                  placeholder="{0} itens selecionados" selectedItemsLabel="{0} itens selecionados">
                </p-multiSelect>
              </div>
            </div>
          </div>
          <div class="modal-footer modal-footer-checklist">
            <button type="button" class="btn btn-sm btn-secondary" (click)="displaySeguirCardModal='none'"><i
                class="fas fa-undo"></i> Cancelar</button>
            <button type="button" class="btn btn-sm btn-primary" (click)="seguirCard(true)"><i class="fas fa-check"></i>
              Salvar</button>
          </div>
        </div>
      </div>
    </div> <!-- /.modal seguir card-->

    <!-- .modal definir aprovador do card (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayDefinirAprovadorModalCard}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDefinirAprovadorModalCard}"
      style="left: inherit; right: 7.3%; top: 12px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()"><span
                aria-hidden="true">&times;</span></button>
            <h4 class="modal-title modal-title-etiquetas">Aprovador do cartão</h4>
          </div>
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <div class="list-group" *ngIf="displayDefinirAprovadorModalCard !== 'none'">
                  <a class="list-group-item list-group-item-action" style="cursor:pointer;"
                    *ngFor="let part of participantesProjeto" (click)="definirAprovadorCard(part)">
                    {{ part.usuario.fullName }}
                    <span style="display:-webkit-inline-box;" *ngIf="indexCurrentCard.aprovador === part.usuario.id">
                      <i class="d-block far fa-check-circle" style="color: green;"></i></span>
                  </a>
                  <a class="list-group-item list-group-item-action" style="cursor:pointer;"
                    (click)="definirAprovadorCard(null)">
                    Sem Aprovador
                    <span style="display:-webkit-inline-box;" *ngIf="indexCurrentCard.aprovador === null">
                      <i class="d-block far fa-check-circle" style="color: green;"></i></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal definir aprovador do card!-->

    <!-- .modal anexo
      <div class="backdrop" [ngStyle]="{'display':displayAnexoModal}"></div>
      <div class="modal modal-seguir-card" tabindex="-1" role="dialog" [ngStyle]="{'display':displayAnexoModal}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()" style="right: 7px;">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title modal-title-etiquetas">Inserir anexo</h4>
            </div>
            <div class="modal-body">
              <form class="form-inline">
                <div class="form-group">
                  <div class="list-group">
                    <div class="input-group">

                      <div *ngIf="categoriaList.length > 0" class="lks-form-grid">
                        <div class="input-12 type-p-dropdown" input-vertical="middle" style="width: 310px">
                          <p-dropdown
                            [options]="categoriaList"
                            [(ngModel)]="categoriaId"
                            [ngModelOptions]="{standalone: true}"
                            (onChange)="openAnexoSelect()"
                            placeholder="Categoria"
                            [filter]="true">
                          </p-dropdown>
                        </div>
                      </div>

                      <div *ngIf="categoriaList.length === 0" class="lks-form-grid">
                        <div class="input-12" input-vertical="middle">
                          <b>Sem categorias</b>
                        </div>
                      </div>

                      <div *ngIf="enableInput" style="display:none" class="input-12" input-vertical="middle">
                        <input id="file-upload" type="file" (change)="anexoChange($event);" #file/>
                      </div>

                      <div class="modal-footer modal-footer-checklist" style="padding: 10px 0 0 113px">
                        <button type="button" class="btn btn-default" (click)="onCloseHandled();categoriaId=null;">Cancelar</button>
                      </div>

                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>  /.modal anexo-->

    <!-- .modal regra do cartão (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayStatusModal}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStatusModal}"
      style="left: inherit; right: 1.7%; top: 171px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title modal-title-etiquetas">Definir regra do cartão</h4>
          </div>
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <div class="list-group" *ngIf="displayStatusModal !== 'none'">
                  <a class="list-group-item list-group-item-action" style="cursor:pointer;"
                    *ngFor="let alcada of alcadasCardList" (click)="salvarAlcadaCard(alcada)">
                    {{ alcada.label }}
                    <span style="display:-webkit-inline-box;" *ngIf="indexCurrentCard.alcada === alcada.value">
                      <i class="far fa-check-circle" style="color: green;"></i></span>
                  </a>
                  <a class="list-group-item list-group-item-action" style="cursor:pointer;"
                    (click)="salvarAlcadaCard(null)">
                    Sem Regra
                    <span style="display:-webkit-inline-box;" *ngIf="indexCurrentCard.alcada === null">
                      <i class="far fa-check-circle" style="color: green;"></i></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal status!-->

    <!-- .modal Categoria anexo - DragAndDrop (FEITO)-->
    <div class="backdrop" [ngStyle]="{'display':displayCategoriaAnexo}"></div>
    <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayCategoriaAnexo}"
      style="left: inherit; right: 1.7%; top: 411px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()"><span
                aria-hidden="true">&times;</span></button>
            <h4 class="modal-title modal-title-etiquetas">Selecionar categoria</h4>
          </div>
          <div class="modal-body">
            <div class="form-row" *ngIf="categoriaList.length > 0">
              <div class="form-group col-sm-12">
                <label>Selecione</label>
                <p-dropdown class="type-p-dropdown" [options]="categoriaList" [(ngModel)]="categoriaId"
                  [ngModelOptions]="{standalone: true}" (onChange)="selecionarCategoriaAnexo();" placeholder="Categoria"
                  [filter]="true">
                </p-dropdown>
              </div>
            </div>
            <div class="form-row" *ngIf="categoriaList.length === 0">
              <div class="form-group col-sm-12">
                <div class="alert alert-xs alert-primary">
                  <i class="fas fa-info-circle"></i> Sem categoria
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer modal-footer-checklist">
            <button type="button" class="btn btn-sm btn-secondary" (click)="onCloseHandled();categoriaId=null;"><i
                class="fas fa-undo"></i> Cancelar</button>
          </div>
        </div>
      </div><!-- /.modal-dialog -->
    </div> <!-- /.modal Categoria anexo - DragAndDrop-->

  </ng-template> <!-- /.modal cartão!-->

  <!-- .modal definir aprovador da lista (FEITO)-->
  <div class="backdrop" [ngStyle]="{'display':displayDefinirAprovadorModal}"></div>
  <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDefinirAprovadorModal}"
    style="left: 50%; right: 0; top: 24%;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()"><span
              aria-hidden="true">&times;</span></button>
          <h4 class="modal-title modal-title-etiquetas">Aprovador da lista</h4>
        </div>
        <div class="modal-body" style="overflow-y: auto; max-height: 400px;">
          <div class="form-row">
            <div class="form-group col-sm-12">
              <div class="list-group" *ngIf="displayDefinirAprovadorModal !== 'none'">
                <a class="list-group-item list-group-item-action" style="cursor:pointer;"
                  *ngFor="let part of participantesProjeto" (click)="definirAprovador(part)">
                  {{ part.usuario.fullName }}
                  <span style="display:-webkit-inline-box;" *ngIf="indexCurrentPainel.aprovador === part.usuario.id">
                    <i class="d-block far fa-check-circle" style="color: green;"></i></span>
                </a>
                <a class="list-group-item list-group-item-action" style="cursor:pointer;"
                  (click)="definirAprovador(null)">
                  Sem Aprovador
                  <span style="display:-webkit-inline-box;" *ngIf="indexCurrentPainel.aprovador === null">
                    <i class="d-block far fa-check-circle" style="color: green;"></i></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal definir aprovador da lista!-->

  <!-- .modal mover cards da lista (FEITO)-->
  <div class="backdrop" [ngStyle]="{'display':displayMoverCardsList}"></div>
  <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayMoverCardsList}"
    style="left: 50%; right: 0; top: 24%;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()"><span
              aria-hidden="true">&times;</span></button>
          <h4 class="modal-title modal-title-etiquetas">Mover {{moveAll?'todos cartões':'cartão'}}</h4>
        </div>
        <div class="modal-body" style="overflow-y: auto; max-height: 400px;">
          <div class="form-row">
            <div class="form-group col-sm-12">
              <div class="list-group">
                <div class="input-group">
                  <a class="list-group-item list-group-item-action" style="cursor:pointer;padding:.3rem .6rem;"
                    *ngFor="let list of listMoverCards"
                    (click)="moveAll?moveAllCards(list):moveCard(list);displayMoverCardsList='none'"> {{ list.name }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="listas.length===0">
            <div class="form-group col-sm-12">
              <div class="alert alert-xs alert-primary">
                <i class="fas fa-info-circle"></i> Sem painel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal mover cards!-->

  <!-- .modal desarquivar listas e cartões (FEITO)-->
  <div class="backdrop" [ngStyle]="{'display':displayUnarchiveList}" (click)="onCloseHandled()"></div>
  <div class="modal modal-custom" tabindex="-1" role="dialog" [ngStyle]="{'display':displayUnarchiveList}"
    style="left: 50%; right: 0; top: 24%;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close modal-close" aria-label="Close" (click)="onCloseHandled()"><span
              aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">Desarquivar {{mdItem}}</h4>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group col-sm-12">
              <label>Desarquivar</label>
              <!-- {{mdItem}}: -->
              <p-dropdown class="type-p-dropdown" [(ngModel)]="mdOption" [options]="mdOptionList"
                defaultLabel="Selecione" [filter]="true">
              </p-dropdown>
              <!--<div class="form-group">
          <multiselect class="input-xlarge multiselect" ng-model="vm.option6"
          options="p.key as p.value for p in vm.options1" select-limit="5"
                       header="Select Stuff6 Prepopulated" selected-header="options selected" multiple="true" enable-filter="true" filter-placeholder="Filter stuff..">
          </multiselect>-->
            </div>
          </div>
        </div>
        <div class="modal-footer modal-footer-checklist">
          <button type="button" class="btn btn-sm btn-secondary" (click)="onCloseHandled()"><i class="fas fa-undo"></i>
            Cancelar</button>
          <button type="button" class="btn btn-sm btn-primary" (click)="desarquivar()"><i class="fas fa-check"></i>
            Desarquivar</button>
        </div>
      </div>
    </div><!-- /.modal-dialog -->
  </div>
  <!--/.modal desarquivar!-->

  <!-- Modla Editar Projeto (FEITO)-->
  <p-dialog header="editar projeto" [(visible)]="modalEditarProjeto" appendTo="body" [closable]="true" [modal]="true"
    [responsive]="true" styleClass="modal-initial" [style]="{width: '900px'}">
    <div class="form-row">
      <div class="form-group col-sm-9">
        <label>Nome</label>
        <input class="form-control" [(ngModel)]="mepNome" />
      </div>
      <div class="form-grouo col-sm-3">
        <label>key</label>
        <input class="form-control" [(ngModel)]="mepKey" maxlength="4" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-9">
        <label>Departamento</label>
        <p-dropdown class="type-p-dropdown" [(ngModel)]="mepDepartamento" [options]="mepDepartamentoList"
          [filter]="true">
        </p-dropdown>
      </div>
      <div class="form-grouo col-sm-3">
        <label>Cor</label>
        <input class="form-control" style="height: 33px; cursor: pointer" type="color" name="favcolor"
          [(ngModel)]="mepCor" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-9">
        <label>Participantes</label>
        <p-multiSelect class="type-p-mult" [(ngModel)]="mepUsuarios" [options]="mepUsuariosList"
          (ngModelChange)="loadAdms()" defaultLabel="Adicionar / remover participantes" [filter]="true"
          placeholder="{0} itens selecionados" selectedItemsLabel="{0} itens selecionados"></p-multiSelect>
      </div>
      <div class="form-grouo col-sm-3">
        <label>Owner</label>
        <p-dropdown class="type-p-dropdown" [(ngModel)]="mepOwner" [options]="mepOwnerList" [filter]="true">
        </p-dropdown>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-9">
        <label>Administradores:</label>
        <p-multiSelect class="type-p-mult" [(ngModel)]="mepAdms" [options]="mepAdmsList"
          defaultLabel="Adicionar / remover administradores" [filter]="true" placeholder="{0} itens selecionados"
          selectedItemsLabel="{0} itens selecionados">
        </p-multiSelect>
      </div>
      <div class="form-grouo col-sm-3">
        <label>Ordenar</label>
        <p-dropdown class="type-p-dropdown" [(ngModel)]="mepOrdenacao" [options]="mepOrdenacaoList" [filter]="true">
        </p-dropdown>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-12">
        <mat-slide-toggle class="mr-3" matTooltip="inserir automaticamente todos os participantes a cada cartão criado"
          [(ngModel)]="addParticipantes">Inserir participantes</mat-slide-toggle>
        <mat-slide-toggle class="mr-3" *ngIf="addParticipantes"
          matTooltip="quando estiver ativo, os novos participantes serão incluidos nos cards já criados"
          [(ngModel)]="addParticipantesOld">Incluir Participantes em Cards Antigos</mat-slide-toggle>
        <mat-slide-toggle matTooltip="quando estiver ativo, o card não poderá ser movido na vertical"
          [(ngModel)]="blockMovVertical">Bloquear Movimentação Vertical</mat-slide-toggle>
      </div>
    </div>

    <div class="ui-g" style="position: fixed; right: 15px; bottom: 5px; max-width: 500px;">
      <div class="ui-g-12">
        <p-messages [value]="msgsModal" (click)="hideMessage()"></p-messages>
      </div>
    </div>

    <p-footer>
      <button type="button" class="btn btn-secondary" (click)="onCloseHandled()"><i class="fas fa-undo"></i>
        Cancelar</button>
      <button type="button" class="btn btn-primary" (click)="alterarProjeto()"><i class="fas fa-check"></i>
        Salvar</button>
    </p-footer>
  </p-dialog>

  <!-- Modal Usuário Substituto (FEITO)-->
  <p-dialog header="Informar Usuário Substituto" [(visible)]="modalUsuarioSubstituto" appendTo="body" [closable]="true"
    [modal]="true" [responsive]="true" styleClass="modal-initial" [style]="{width: '800px'}">
    <div class="row">
      <div class="col">
        <div class="alert alert-xs alert-primary mt-2">
          <i class="fas fa-info-circle"></i> O(s) usuário(s) que você está removendo do projeto participa(m) como
          <strong>responsável/requisitante de algum card</strong>, informe o <strong>usuário substituto</strong>:
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label>Usuário</label>
        <p-dropdown class="type-p-dropdown" [(ngModel)]="usuarioSubstituto" [options]="mepAdmsListSubstituto"
          [filter]="true" defaultLabel="Selecione"></p-dropdown>
      </div>
    </div>
    <p-footer>
      <button type="button" class="btn btn-secondary" (click)="onCloseHandled()"><i class="fas fa-undo"></i>
        Cancelar</button>
      <button type="button" class="btn btn-primary" [disabled]="usuarioSubstituto === 0" (click)="alterarProjeto()"><i
          class="fas fa-check"></i> Salvar</button>
    </p-footer>
  </p-dialog>

  <!-- Modal Marcadores Projeto (FEITO) -->
  <p-dialog header="Marcadores projeto" [(visible)]="modalEtiquetaProjeto" appendTo="body" [closable]="true"
    [modal]="true" [responsive]="true" styleClass="modal-scroll" [style]="{width: '450px'}"
    [contentStyle]="{'min-height':'300px'}">
    <div class="form-row">
      <div class="form-group col-sm-10">
        <label>Nome</label>
        <input class="form-control" type="text" name="nomeEtiqueta" [(ngModel)]="etiqueta.nome" />
      </div>
      <div class="form-group col-sm-2">
        <label>Cor</label>
        <input class="form-control" style="height: 33px; cursor: pointer;" type="color" name="corEtiqueta"
          [(ngModel)]="etiqueta.corBg" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-12 mb-1">
        <label>Descrição</label>
        <textarea class="form-control" rows="3" [(ngModel)]="etiqueta.descricao"></textarea>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-12 text-right">
        <button class="btn btn-sm btn-secondary" (click)="cancelEtiqueta()"><i class="fas fa-times"></i>
          Cancelar</button>
        <button class="btn btn-sm btn-primary" (click)="salvarEtiquetas()"><i class="fas fa-check"></i> Salvar</button>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-12">
        <p-table styleClass="p-datatable-sm p-datatable-striped" cellpadding="10" cellspacing="10"
          [value]="etiquetaList">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 85%;">Marcadores</th>
              <th class="text-center" style="width: 15%">Ação</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr style="border-bottom: 1px solid #a4a4a4;">
              <td
                [ngStyle]="{'background-color':rowData.corBg,'cursor':'pointer','color':'white','height':'40px','border-color':'#a4a4a4' }"
                matTooltip="Editar Marcadores" (click)="editarEtiqueta(rowData)">
                {{ rowData.nome }}
              </td>
              <td class="text-center"
                [ngStyle]="{'background-color':rowData.corBg,'cursor':'pointer','color':'white','height':'40px','vertical-align':'middle','border-color':'#a4a4a4'}">
                <img matTooltip="Editar Marcadores" (click)="editarEtiqueta(rowData)"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wELDSM2z64clgAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAFdSURBVDjLnZKxSgNREEXvzNsHYcOmtLLQTxAEIRoCCiKEVH6AYmftf2hvaWEtRAgpTCKaDf6FYGEf2SWw+961SCJKTLLaHuYUc2akWt0x43FGYwRhqAoQzinSNPerGajjcUZVShiKWusFABaxOI5PBoPhR7vdP50wRzVGUC4bsZaSZcIkcQQwx+L45VJEdkkOg8BedzrPZ3nuoWGoWkQG0BSRfQCvJHuqelWpWA0Aoog8Go0ORARRFHVJPjjnboOAos4pisjHx0dv1loCIIC02dy7cU6oaZr7InKr1V0vlUpdkveNRvViOueD6Vn+I/PXiEVlAJiL+Be5XDZizLeI/f7TJoBzABARrJKtpTgnDNI096oQVa2R7Hnv76Io6gLgMnkW8esTjTGHAKyq1gCsFZB/RgSwISLvJB+TJNlaJc8iSr2+HQDAssFFbBoRTBLn89wzDCdwtt8q5pz4T0qu1GgSCFOOAAAAAElFTkSuQmCC" />
                <img height="14px" matTooltip="Excluir Marcadores" (click)="removerEtiqueta(rowData)"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAADVHpUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHjaxZZrkuMqDEb/axWzBEsgJJaDH1TNDu7y54PQTsdJp/OquqZisCwkoSNwaPvvb6U/uDj7RFHNU05pwhVzzFIw8Ol0nXqeYr+Ph+lrcCGn/YVAFNCH02Pahn6BXM8TLA75fCknW4YdH4Z4N9yv0Dy38dDzYSjISc7jmfKYV+K35YyfLMPsMH58joZkrAp7QUi2wGHC3ZuXgAhCDqX3BT+WNmpjQWt3v5072oeH5O2jQ+6mMuThMhU0paGQDjkactaDPOxu5Ejty/PFi5J2F1e5q3X1WrfT6kpMyFSisaivpfQRFGekMvRpzaDhpxhbbxnNscQFxFbQnNEW4syCbFeOvHLhylvvF14QYpRNDL3IIqHLPJhkWTqM2BpXMeBZKThILKAWIJY9Fu5+c/e3sMPzytAUhjHuBA+NbglfabuhWlvpMk++5wpxSatphNHItTu0AITryKn2/PZG3+pm+gY2gKD2NDsWWKb5ZGJWPtdW6JwD9HSKNJ22Bts6DCBF8K0IBhUdeUoclBNPJmLMyKODT0HkEqLMIMCqsjJVsAkhAY5L8405xl1XVE5iHC0AoSEFAxpsIMCKUVE/Fh01VDRoJFVNauqataSQYtKUkqV2RhULFk0tmZlbtuLBo6snN3fPXrLkgCNMc8pG2XPOpcBpgemC2QUapcwyhznOOqfZZp/zXBaUzxIXXdJiiy95KausYcX2X9NqtPqa17LxhlLa4qZb2mzzLW+lotZqqLFqTdWq11zLTm1QvaTGB3L3qfGg1ojFrmdnahCbfZngdpxoYwZiEhnErRFAQUtjNjnHKI1cYzZlwaZQATXWBmflRgwE48ailXd2Z3J3uZHGp7jJT+SoofsEOWroBrlrbjeoraV/UUIH1HZhy+kUKg42KGxexEv7Jt3v67yVH17Rj3Oc04Pme0+v+b/u6e14hjt6OPZf+ocM3Yjvatn0mXjuGnokjgfwP9vTE7xuxHPWppdDOJilB6vm1+L8ALVTGPReHB+gdkwHvbtZf9m0zx8u9F4c72/aKxV6L45XN+0dLP/Lpr2LhT4Tz27o/W37kcO/hUHvHh8fOEYu00Hvf2NfrKNb3xb8R8n0D6y7thLP2/fJAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wELDRYjAEI6ywAAAO1JREFUOMvt0zFKQ0EQgOEvISxJmoDGSkkpVh5CBA8ggh7goXew9g7G0kZBPIBgZ5teL2AXAykSYRptptD4MARbB7bYf/+Z3Z1lqYmIqCJiFhEfOWYRUdW5jZrkDt5wi4fEBzjGeinl/avfyqQuLtDFGjroYS+9XrLriJhgjvNSyryRBU5xabU4K6UMmzmprB7V4t2HETFalhURo4gYfuvBgrCNO5zgMPE9bnC06LdqNmljN5u2layTrL0oN/0x/gvUv8IEVxjjKdk42eS3AlNsYJByH8+51k82SGf64zdGxCYesbPk1C/YL6W8wie87lOMbLn/2wAAAABJRU5ErkJggg==" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="ui-g" style="position: fixed; right: 15px;  bottom: 5px; max-width: 500px;">
      <div class="ui-g-12">
        <p-messages [value]="msgsModal" (click)="hideMessage()"></p-messages>
      </div>
    </div>
    <p-footer>
      <button type="button" class="btn btn-secondary" (click)="onCloseHandled()"><i class="fas fa-undo"></i>
        Fechar</button>
      <!-- <button type="button" class="btn btn-primary" (click)="salvarEtiquetas()"><i class="fas fa-check"></i> Adicionar</button> -->
    </p-footer>
  </p-dialog>

  <!-- Modal Convidar Participante (FEITO)-->
  <p-dialog header="convidar participante" [(visible)]="modalConvidarParticipante" appendTo="body" [closable]="true"
    [modal]="true" [responsive]="true" styleClass="modal-initial" [style]="{width: '700px'}">
    <div class="form-row">
      <div class="form-group col-sm-10">
        <label>e-mail</label>
        <input class="form-control" [(ngModel)]="mcpInput" />
      </div>
      <div class="form-group col-sm-2">
        <label style="visibility: hidden; margin-top: -13px;">DO NOT REMOVE</label>
        <button type="button" class="btn btn-sm btn-info" (click)="adicionarEmail()"
          [class.disabled]="mcpInput.indexOf('@') === -1">
          <i class="fas fa-plus"></i> Adicionar
        </button>
        <!-- <button type="button" *ngIf="mcpInput.indexOf('@') !== -1" class="btn btn-sm btn-info" (click)="adicionarEmail()"><i class="fas fa-plus"></i> Adicionar</button> -->
      </div>
    </div>
    <div class="form-row" *ngIf="mcpEmailList.length>0">
      <div class="form-group col-sm-12">
        <label>lista</label>
        <p-multiSelect class="type-p-mult" [(ngModel)]="mcpEmail" [options]="mcpEmailList"
          defaultLabel="Adicionar / remover convidados" [filter]="true" placeholder="{0} itens selecionados"
          selectedItemsLabel="{0} itens selecionados">
        </p-multiSelect>
      </div>
    </div>
    <div class="ui-g" style="position: fixed; right: 15px;  bottom: 5px; max-width: 500px;">
      <div class="ui-g-12">
        <p-messages [value]="msgsModal" (click)="hideMessage()"></p-messages>
      </div>
    </div>
    <p-footer>
      <button type="button" class="btn btn-secondary" (click)="onCloseHandled()"><i class="fas fa-undo"></i>
        Cancelar</button>
      <button type="button" *ngIf="mcpEmail.length>0" class="btn btn-primary" (click)="enviarEmail()"><i
          class="fas fa-check"></i> Enviar</button>
    </p-footer>
  </p-dialog>
  <p-toast position="bottom-right" key="modal"></p-toast>
  <!-- Modal Categorias Anexo (FEITO) -->
  <p-dialog header="categorias anexo" [(visible)]="modalCategoriasAnexo" appendTo="body" [closable]="true"
    [modal]="true" [responsive]="true" styleClass="modal-scroll" [style]="{width: '450px'}"
    [contentStyle]="{'min-height':'300px'}">
    <div class="form-row">
      <div class="form-group col-sm-12 mb-1">
        <label>Nome</label>
        <input class="form-control" type="text" [(ngModel)]="categoriaNome" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-12 text-right">
        <button type="button" class="btn btn-sm btn-secondary" (click)="onCloseHandled()"><i class="fas fa-times"></i>
          Cancelar</button>
        <button type="button" class="btn btn-sm btn-primary" (click)="salvarCategoria()"><i class="fas fa-check"></i>
          Salvar</button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <p-table styleClass="p-datatable-sm p-datatable-striped" [value]="categoriaList">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 85%;">Categorias</th>
              <th style="width:15%;" class="text-center">Ação</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td style="cursor: pointer;" (click)="editarCategoria(rowData)">
                {{ rowData.label }}
              </td>
              <td class="text-center">
                <span class="edit" matTooltip="Editar Categoria" (click)="editarCategoria(rowData)"><i
                    class="fas fa-pencil-alt"></i></span>
                <span class="delete" matTooltip="Excluir Categoria" (click)="excluirCategoria(rowData)"><i
                    class="far fa-trash-alt"></i></span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-rowData>
            <tr style="height:25px">
              <td [attr.colspan]="2" class="spaced-alert">
                <div class="alert alert-xs alert-primary d-inline" role="alert">
                  <i class="fas fa-info-circle"></i> Nenhuma Categoria Adicionada!
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="ui-g" style="position: fixed; right: 15px; bottom: 5px; max-width: 500px;">
      <div class="ui-g-12">
        <p-messages [value]="msgsModal" (click)="hideMessage()"></p-messages>
      </div>
    </div>
    <p-footer>
      <button type="button" class="btn btn-secondary" (click)="onCloseHandled()"><i class="fas fa-undo"></i>
        Fechar</button>
    </p-footer>
  </p-dialog>

  <!-- Modal Regras (FEITO) -->
  <p-dialog header="regras" appendTo="body" [closable]="true" [modal]="true" [responsive]="true"
    styleClass="modal-scroll" [style]="{width: '1000px'}" [contentStyle]="{'min-height':'300px'}">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label>Regra</label>
        <p-dropdown class="type-p-dropdown" appendTo="body" [(ngModel)]="alcadaId" [options]="alcadasList"
          (onChange)="triggerAlcadasRegras()" [filter]="true" defaultLabel="Selecione"></p-dropdown>
      </div>
    </div>
    <div class="form-row" *ngIf="alcadaId!==null&&alcadaId!==undefined">
      <div class="form-group col-sm-12">
        <label>Nome</label>
        <input class="form-control" type="text" [(ngModel)]="alcadaDescricao" />
      </div>
    </div>
    <p-table styleClass="p-datatable-sm p-datatable-striped" [value]="alcadasRegrasList">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 20%;">Origem</th>
          <th style="width: 20%;">Ação</th>
          <th style="width: 35%;">Destino</th>
          <th style="width: 15%;" class="text-center">Aceite / Recusa</th>
          <th style="width: 10%;" class="text-center">Ação</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td>
            <div class="form-row">
              <div class="form-group col-sm-12 mb-0">
                <p-dropdown class="type-p-dropdown" appendTo="body" [(ngModel)]="rowData.todoPainelIni.id"
                  [options]="alcadasPainelIniList"
                  (onChange)="triggerAlcadasPainelIni(rowData);triggerAlcadasPainelFin(rowData)" [filter]="true"
                  defaultLabel="Selecione" emptyFilterMessage="Nenhuma lista encontrada"></p-dropdown>
              </div>
            </div>
          </td>
          <td>
            <div class="form-row">
              <div class="form-group col-sm-12 mb-0">
                <p-dropdown class="type-p-dropdown" appendTo="body" [(ngModel)]="rowData.todoAlcadasAcoes.id"
                  [options]="alcadasAcoesList"
                  (onChange)="triggerAlcadasPainelIni(rowData);triggerAlcadasPainelFin(rowData)" [filter]="true"
                  defaultLabel="Selecione"></p-dropdown>
              </div>
            </div>
          </td>
          <td>
            <div class="form-row">
              <!--lista completa com todos os projetos-->
              <div class="form-group col-sm-12 mb-0" *ngIf="rowData.todoAlcadasAcoes.id!==1"
                matTooltip="{{rowData.todoPainelFin.id!==null?getPainelLabel(rowData.todoPainelFin.id):'Selecione'}}">
                <p-dropdown class="type-p-dropdown" appendTo="body" [(ngModel)]="rowData.todoPainelFin.id"
                  [options]="alcadasPainelFinList"
                  (onChange)="triggerAlcadasPainelIni(rowData);triggerAlcadasPainelFin(rowData)" [filter]="true"
                  defaultLabel="Selecione" emptyFilterMessage="Nenhuma lista encontrada"></p-dropdown>
              </div>
              <!--lista somente do projeto selecionado-->
              <div class="form-group col-sm-12 mb-0" *ngIf="rowData.todoAlcadasAcoes.id===1"
                matTooltip="{{rowData.todoPainelFin.id!==null?getPainelLabel(rowData.todoPainelFin.id):'Selecione'}}">
                <p-dropdown class="type-p-dropdown" appendTo="body" [(ngModel)]="rowData.todoPainelFin.id"
                  [options]="alcadasPainelFinListTEMP"
                  (onChange)="triggerAlcadasPainelIni(rowData);triggerAlcadasPainelFin(rowData)" [filter]="true"
                  defaultLabel="Selecione" emptyFilterMessage="Nenhuma lista encontrada"></p-dropdown>
              </div>
            </div>
          </td>
          <td class="text-center">
            <mat-radio-group class="mt-2" [(ngModel)]="rowData.aprovacao"
              (change)="triggerAlcadasPainelIni(rowData);triggerAlcadasPainelFin(rowData)">
              <mat-radio-button class="mr-3 pt-2" [value]=true></mat-radio-button>
              <mat-radio-button [value]=false></mat-radio-button>
            </mat-radio-group>
          </td>
          <td class="text-center">
            <span class="delete" *ngIf="alcadasRegrasList.length>1" (click)="excluirRegra(rowData)"><i
                class="far fa-trash-alt"></i></span>
            <span class="edit" *ngIf="getRegrasLastId(rowData)" (click)="inserirRegra(false)"><i
                class="fas fa-plus"></i></span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-rowData>
        <tr style="height:25px">
          <td [attr.colspan]="5" class="spaced-alert">
            <div class="alert alert-xs alert-primary d-inline" role="alert">
              <i class="fas fa-info-circle"></i> Nenhuma Regra Adicionada!
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!--<div class="lks-form-grid">
    <div class="input-12" input-vertical="middle">
      <div class="lks-modal-button" style="float: right;">
        <button mat-raised-button class="button-default" (click)="onCloseHandled();startGetListas()">Cancelar</button>
        <button mat-raised-button class="button-red" (click)="excluirAlcada()" *ngIf="alcadaId>0">Excluir</button>
        <button mat-raised-button class="button-green" (click)="salvarAlcada()" *ngIf="alcadasRegrasList.length>0&&alcadasBtnAprovacao">Salvar</button>
      </div>
    </div>
  </div>-->
    <div class="ui-g" style="position: fixed; right: 15px;  bottom: 5px; max-width: 500px;">
      <div class="ui-g-12">
        <p-messages [value]="msgsModal" (click)="hideMessage()"></p-messages>
      </div>
    </div>
    <p-footer>
      <button type="button" class="btn btn-secondary" (click)="onCloseHandled();startGetListas()"><i
          class="fas fa-undo"></i> Cancelar</button>
      <button type="button" class="btn btn-danger" (click)="excluirAlcada()" *ngIf="alcadaId>0"><i
          class="fas fa-times"></i> Excluir</button>
      <button type="button" class="btn btn-primary" (click)="salvarAlcada()"
        *ngIf="alcadasRegrasList.length>0&&alcadasBtnAprovacao"><i class="fas fa-check"></i> Salvar</button>
    </p-footer>
  </p-dialog>

  <!-- Modal Aprovar Card (FEITO)-->
  <p-dialog header="Deseja aprovar este cartão?" [(visible)]="modalAssinarCard" appendTo="body" [closable]="true"
    [modal]="true" [responsive]="true" styleClass="modal-initial" [style]="{width: '420px'}">
    <div class="form-row">
      <div class="form-group col-sm-12 mt-3 text-center">
        <button type="button" class="btn btn-secondary" (click)="modalAssinarCard=false;startGetListas()"><i
            class="fas fa-undo"></i> Cancelar</button>
        <button type="button" class="btn btn-danger" (click)="assinarCardAction(false, true)" *ngIf="assBtnRecusa"><i
            class="fas fa-times"></i> Rejeitar</button>
        <button type="button" class="btn btn-primary" (click)="assinarCardAction(true, true)"><i
            class="fas fa-check"></i>
          Aprovar</button>
      </div>
    </div>
  </p-dialog>

  <!-- Modal Aprovar todos os cartões (FEITO)-->
  <p-dialog header="Aprovar os cartões desta lista?" [(visible)]="modalAssinarCards" appendTo="body" [closable]="true"
    [modal]="true" [responsive]="true" styleClass="modal-initial" [style]="{width: '420px'}">
    <div class="form-row">
      <div class="form-group col-sm-12 mt-3 text-center">
        <button type="button" class="btn btn-secondary" (click)="modalAssinarCards=false;startGetListas()"><i
            class="fas fa-undo"></i> Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="assinarCardsAction()"><i class="fas fa-check"></i>
          Aprovar</button>
      </div>
    </div>
  </p-dialog>

  <!-- Modal Filtrar por (FEITO)-->
  <p-dialog header="filtrar por" [(visible)]="modalFiltrar" appendTo="body" [closable]="true" [modal]="true"
    [responsive]="true" styleClass="modal-initial" [style]="{width: '800px'}">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label>Que contém</label>
        <input class="form-control" [(ngModel)]="mepContem" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-6">
        <label>Requisitante</label>
        <p-multiSelect class="type-p-mult" [(ngModel)]="mepRequisitante" [options]="mepUsuariosList"
          defaultLabel="Selecionar requisitante" [filter]="true" placeholder="0 itens selecionados"
          selectedItemsLabel="0 itens selecionados"></p-multiSelect>
      </div>
      <div class="form-group col-sm-6">
        <label>Prioridade</label>
        <p-multiSelect class="type-p-mult" [(ngModel)]="mepPrioridade" [options]="listaPrioridade"
          defaultLabel="Selecionar Prioridade" [filter]="true" placeholder="0 itens selecionados"
          selectedItemsLabel="0 itens selecionados">
        </p-multiSelect>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-6">
        <label>Responsável</label>
        <p-multiSelect class="type-p-mult" [(ngModel)]="mepResponsavel" [options]="mepUsuariosList"
          defaultLabel="Selecionar Responsável" [filter]="true" placeholder="0 itens selecionados"
          selectedItemsLabel="0 itens selecionados">
        </p-multiSelect>
      </div>
      <div class="form-group col-sm-6">
        <label>Marcador</label>
        <p-multiSelect [(ngModel)]="mepMarcador" [options]="mepEtiquetaList" defaultLabel="Selecionar Marcador"
          [filter]="true" placeholder="0 itens selecionados" selectedItemsLabel="0 itens selecionados">
        </p-multiSelect>
      </div>
    </div>
    <div class="ui-g" style="position: fixed; right: 15px; bottom: 5px; max-width: 500px;">
      <div class="ui-g-12">
        <p-messages [value]="msgsModal" (click)="hideMessage()"></p-messages>
      </div>
    </div>
    <p-footer>
      <button class="btn btn-secondary" (click)="limparFiltro()"><i class="fas fa-undo"></i> Limpar Filtro</button>
      <button class="btn btn-primary" (click)="filtrarCards()"><i class="fas fa-search"></i> Pesquisar</button>
    </p-footer>
  </p-dialog>

  <div *ngIf="modalAlcadas" class="box-content"
    style="padding:1.8rem !important; margin-left: 20px; margin-right: 20px">

    <div class="form-row">
      <div class="form-group col-sm-12">
        <label>Regra</label>
        <p-dropdown class="type-p-dropdown" appendTo="body" [(ngModel)]="alcadaId" [options]="alcadasList"
          (onChange)="triggerAlcadasRegras()" [filter]="true" defaultLabel="Selecione"></p-dropdown>
      </div>
    </div>
    <div class="form-row" *ngIf="alcadaId!==null&&alcadaId!==undefined">
      <div class="form-group col-sm-12">
        <label>Nome</label>
        <input class="form-control" type="text" [(ngModel)]="alcadaDescricao" />
      </div>
    </div>
    <p-table class="table-border" [value]="alcadasRegrasList">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 20%;">Origem</th>
          <th style="width: 20%;">Ação</th>
          <th style="width: 20%;">Destino</th>
          <th style="width: 15%;" class="text-center">Condição</th>
          <th style="width: 15%;" class="text-center">Aceite / Recusa</th>
          <th style="width: 10%;" class="text-center">Ação</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td>
            <div class="form-row">
              <div class="form-group col-sm-12 mb-0">
                <p-dropdown class="type-p-dropdown" appendTo="body" [(ngModel)]="rowData.todoPainelIni.id"
                  [options]="alcadasPainelIniList"
                  (onChange)="triggerAlcadasPainelIni(rowData);triggerAlcadasPainelFin(rowData)" [filter]="true"
                  defaultLabel="Selecione" emptyFilterMessage="Nenhuma lista encontrada"></p-dropdown>
              </div>
            </div>
          </td>
          <td>
            <div class="form-row">
              <div class="form-group col-sm-12 mb-0">
                <p-dropdown class="type-p-dropdown" appendTo="body" [(ngModel)]="rowData.todoAlcadasAcoes.id"
                  [options]="alcadasAcoesList"
                  (onChange)="triggerAlcadasPainelIni(rowData);triggerAlcadasPainelFin(rowData)" [filter]="true"
                  defaultLabel="Selecione"></p-dropdown>
              </div>
            </div>
          </td>
          <td>
            <div class="form-row">
              <!--lista completa com todos os projetos-->
              <div class="form-group col-sm-12 mb-0" *ngIf="rowData.todoAlcadasAcoes.id!==1"
                matTooltip="{{rowData.todoPainelFin.id!==null?getPainelLabel(rowData.todoPainelFin.id):'Selecione'}}">
                <p-dropdown class="type-p-dropdown" appendTo="body" [(ngModel)]="rowData.todoPainelFin.id"
                  [options]="alcadasPainelFinList"
                  (onChange)="triggerAlcadasPainelIni(rowData);triggerAlcadasPainelFin(rowData)" [filter]="true"
                  defaultLabel="Selecione" emptyFilterMessage="Nenhuma lista encontrada"></p-dropdown>
              </div>
              <!--lista somente do projeto selecionado-->
              <div class="form-group col-sm-12 mb-0" *ngIf="rowData.todoAlcadasAcoes.id===1"
                matTooltip="{{rowData.todoPainelFin.id!==null?getPainelLabel(rowData.todoPainelFin.id):'Selecione'}}">
                <p-dropdown class="type-p-dropdown" appendTo="body" [(ngModel)]="rowData.todoPainelFin.id"
                  [options]="alcadasPainelFinListTEMP"
                  (onChange)="triggerAlcadasPainelIni(rowData);triggerAlcadasPainelFin(rowData)" [filter]="true"
                  defaultLabel="Selecione" emptyFilterMessage="Nenhuma lista encontrada"></p-dropdown>
              </div>
            </div>
          </td>
          <td class="text-center">
            <span class="edit" *ngIf="rowData.condicao != ''" matTooltip="Inserir condição"
              (click)="informarCondicao(rowData)"><i class="fas fa-comment"></i></span>
            <span class="edit" *ngIf="rowData.condicao == ''" matTooltip="Inserir condição"
              (click)="informarCondicao(rowData)"><i class="far fa-comment"></i></span>
          </td>
          <td class="text-center">
            <mat-radio-group class="mt-2" [(ngModel)]="rowData.aprovacao"
              (change)="triggerAlcadasPainelIni(rowData);triggerAlcadasPainelFin(rowData)">
              <mat-radio-button class="mr-3 pt-2" [value]=true></mat-radio-button>
              <mat-radio-button [value]=false></mat-radio-button>
            </mat-radio-group>
          </td>
          <td class="text-center">
            <span class="delete" *ngIf="alcadasRegrasList.length>1" matTooltip="Excluir regra"
              (click)="excluirRegra(rowData)"><i class="far fa-trash-alt"></i></span>
            <span class="edit" *ngIf="getRegrasLastId(rowData)" matTooltip="Inserir regra"
              (click)="inserirRegra(false)"><i class="fas fa-plus"></i></span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-rowData>
        <tr style="height:25px">
          <td [attr.colspan]="6" class="spaced-alert">
            <div class="alert alert-xs alert-primary d-inline" role="alert">
              <i class="fas fa-info-circle"></i> Nenhuma Regra Adicionada!
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!--<div class="lks-form-grid">
  <div class="input-12" input-vertical="middle">
    <div class="lks-modal-button" style="float: right;">
      <button mat-raised-button class="button-default" (click)="onCloseHandled();startGetListas()">Cancelar</button>
      <button mat-raised-button class="button-red" (click)="excluirAlcada()" *ngIf="alcadaId>0">Excluir</button>
      <button mat-raised-button class="button-green" (click)="salvarAlcada()" *ngIf="alcadasRegrasList.length>0&&alcadasBtnAprovacao">Salvar</button>
    </div>
  </div>
</div>-->

    <div *ngIf="exibirCondicao" class="form-row mt-4">

      <div class="form-group col-sm-4 mb-0">

        <!--<p-dataTable class="table-filter-border" #dt6 [(value)]="viewCampos" [rows]="rows"
    [paginator]="true" [pageLinks]="pageLinks" [rowsPerPageOptions]="rowsPerPage"
    selectionMode="single" emptyMessage="Nenhum Registro Encontrado" [scrollable]="false"
    scrollHeight="200px">

    <p-column
      [style]="{'white-space':'nowrap','overflow':'hidden','text-overflow':'ellipsis','text-align':'left', 'width':'30%'}"
      header="campo" field="campo" [filter]="true" filterMatchMode="startsWith" [sortable]="true">
      <ng-template let-rowValue="rowData" pTemplate="body">
        <tr>
          <td (click)="onSelectViewCampo(rowValue)">{{rowValue.campo}}</td>
        </tr>
      </ng-template>
    </p-column>

    <p-column
      [style]="{'white-space':'nowrap','overflow':'hidden','text-overflow':'ellipsis','text-align':'left', 'width':'60%'}"
      header="descricao" field="descricao" [filter]="true" filterMatchMode="startsWith"
      [sortable]="true">
      <ng-template let-rowValue="rowData" pTemplate="body">
        <tr>
          <td (click)="onSelectViewCampo(rowValue)">{{rowValue.descricao}}</td>
        </tr>
      </ng-template>
    </p-column>

    <p-column
      [style]="{'white-space':'nowrap','overflow':'hidden','text-overflow':'ellipsis','text-align':'left', 'width':'20%'}"
      header="tipo" field="tipo" [filter]="true" filterMatchMode="startsWith" [sortable]="true">
      <ng-template let-rowValue="rowData" pTemplate="body">
        <tr>
          <td (click)="onSelectViewCampo(rowValue)">{{rowValue.tipo}}</td>
        </tr>
      </ng-template>
    </p-column>

  </p-dataTable>-->

        <p-table [value]="viewCampos">
          <ng-template pTemplate="header">
            <tr>
              <th>Campo</th>
              <th>Descrição</th>
              <th>Tipo</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-campo>
            <tr>
              <td (click)="onSelectViewCampo(campo)">{{campo.campo}}</td>
              <td (click)="onSelectViewCampo(campo)">{{campo.descricao}}</td>
              <td (click)="onSelectViewCampo(campo)">{{campo.tipo}}</td>
            </tr>
          </ng-template>
        </p-table>

      </div>
      <div class="form-group col-sm-8 mb-0">
        <mark class="d-inline-block mb-1 mt-0" style="font-size: 13px;">Não informar o <strong>WHERE</strong>,
          somente a condição.</mark>
        <div class="form-row">
          <div class="form-group col-sm-12">
            <textarea rows="8" cols="100" [(ngModel)]="sql" class="form-control"></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g" style="position: fixed; right: 15px;  bottom: 5px; max-width: 500px;">
      <div class="ui-g-12">
        <p-messages [value]="msgsModal" (click)="hideMessage()"></p-messages>
      </div>
    </div>
    <!--<p-footer>-->
    <div class="mt-2" *ngIf="!exibirCondicao">
      <button type="button" class="btn btn-secondary" (click)="onCloseHandled();startGetListas()"><i
          class="fas fa-undo"></i> Cancelar</button>
      <button type="button" class="btn btn-danger" (click)="excluirAlcada()" *ngIf="alcadaId>0"><i
          class="fas fa-times"></i> Excluir</button>
      <button type="button" class="btn btn-primary" (click)="salvarAlcada()"
        *ngIf="alcadasRegrasList.length>0&&alcadasBtnAprovacao"><i class="fas fa-check"></i> Salvar</button>
    </div>

    <div class="mt-2" *ngIf="exibirCondicao">

      <button type="button" class="btn btn-primary" (click)="salvarCondicao()"><i class="fas fa-check"></i>
        Salvar</button>
    </div>
    <!--</p-footer>-->
  </div>





  <p-dialog header="origem projeto" [(visible)]="modalOrigemProjeto" appendTo="body" [closable]="true" [modal]="true"
    [responsive]="true" styleClass="modal-initial" width="800">
    <app-fluxo-aprov paramTipo="RMS" classTipo="col-sm-12" [projeto]="todoProjetoId" *ngIf="todoProjetoId > 0">
    </app-fluxo-aprov>
  </p-dialog>